angular.module("time.and.expense.templates", ["main/src/activity-log/activity-log-edit-modal.html", "main/src/activity-log/activity-log.html", "main/src/activity-log/bmp-timeline-cell-header/bmp-timeline-cell-header.html", "main/src/activity-log/bmp-timeline-cell/bmp-timeline-cell.html", "main/src/edit-multiple/edit-multiple-entry.html", "main/src/edit-multiple/edit-multiple-field.html", "main/src/entry/daily-entry/time-and-expense-daily-entry.html", "main/src/entry/daily-entry/time-and-expense-recap/time-and-expense-recap.html", "main/src/entry/entry-form/time-and-expense-entry-form.html", "main/src/entry/grid-entry/time-and-expense-grid-entry-project-details-modal.html", "main/src/entry/grid-entry/time-and-expense-grid-entry-standard-text.html", "main/src/entry/grid-entry/time-and-expense-grid-entry.html", "main/src/entry/time-and-expense-entry.html", "main/src/review/time-and-expense-review.html", "main/src/time-and-expense-page.html", "main/src/timer/grid/timer-list-grid-client.html", "main/src/timer/grid/timer-list-grid-detail.html", "main/src/timer/grid/timer-list-grid-submit.html", "main/src/timer/grid/timer-list-grid-toggle-edit.html", "main/src/timer/timer.html", "main/src/user-preferences-setup/user-preferences-time-and-expense-entry-component.html", "server-check/index.html"]);

angular.module("main/src/activity-log/activity-log-edit-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/activity-log/activity-log-edit-modal.html",
    "<!-- /* i18nextract */'Bluemoon.TimeEntry.Recap.EditConfirmationDialog.MergeEntries' -->\n" +
    "<!-- /* i18nextract */'Bluemoon.TimeEntry.Timer.SubmitSuccessMessageEditEntry' -->\n" +
    "<h1 class=\"no-top-margin\">{{ vm.entryFormType === 1 ? 'Bluemoon.TimeEntry.Recap.EditConfirmationDialog.MergeEntries' : 'Bluemoon.TimeEntry.Timer.SubmitSuccessMessageEditEntry' | translate }}</h1>\n" +
    "<time-and-expense-entry-form\n" +
    "    time-and-expense-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "    time-and-expense-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id)\"\n" +
    "    time-and-expense-entry-form-allow-new=\"true\"\n" +
    "    time-and-expense-entry-form-analytics-context=\"practice_timeAndExpense_activityLog\"\n" +
    "    time-and-expense-entry-form-employee=\"vm.currentEmployee\">\n" +
    "</time-and-expense-entry-form>\n" +
    "");
}]);

angular.module("main/src/activity-log/activity-log.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/activity-log/activity-log.html",
    "<div class=\"container-fluid no-left-padding view-container no-bottom-margin\">\n" +
    "    <h1 class=\"no-top-margin\">{{'Core.Enums.TimeAndExpenseType.ACTIVITYLOG' | translate}}</h1>\n" +
    "    <div ng-form=\"filterDateForm\">\n" +
    "        <div class=\"row\">\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"filterDate\"\n" +
    "            data-bmp-control-group-label=\"{{'Bluemoon.TimeAndExpense.ActivityLog.Date' | translate}}\"\n" +
    "            class=\"col-md-2 col-sm-2 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"activityLog.date\"\n" +
    "                    bmp-bento-datepicker-wrapper-focus-on-event=\"TimeAndExpenseEntryForm-AfterLoad\"\n" +
    "                    ng-model=\"vm.filterDate\"\n" +
    "                    ng-change=\"vm.filterDateChanged()\"\n" +
    "                    name=\"filterDate\"\n" +
    "                    data-ng-required=\"true\"\n" +
    "                    data-qe-id=\"bm-activityLog-filterDate\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" style=\"margin-bottom: 50px; margin-top: 15px; margin-left: 0px; margin-right: 0px;\">\n" +
    "        <!-- Need this margin here to make the tick marks visibile. TODO: move into directive somehow.-->\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div\n" +
    "                ya-no-ui-slider='vm.sliderOptions'\n" +
    "                ya-no-ui-slider-events='vm.sliderEvents'\n" +
    "                ya-no-ui-slider-slide-debounce='300'>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div ng-class=\"vm.isGridSmaller() ? 'col-md-8': 'col-md-12'\">\n" +
    "            <div class=\"setup-list-grid-view\">\n" +
    "                <div class=\"filters\">\n" +
    "                    <bmp-grid data-bmp-grid-definition=\"vm.definition\" data-bmp-grid-service=\"vm.provider\"></bmp-grid>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/activity-log/bmp-timeline-cell-header/bmp-timeline-cell-header.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/activity-log/bmp-timeline-cell-header/bmp-timeline-cell-header.html",
    "<div style=\"width: 100%; height: 20px\">\n" +
    "    <span ng-repeat=\"timeSegment in vm.timeSegments\" ng-style=\"::vm.getTickStyle(timeSegment)\">{{timeSegment.time}}{{timeSegment.timeOfDayString}}</span>\n" +
    "</div>\n" +
    "<div style=\"width: 100%; height: 20px\">\n" +
    "    <span ng-repeat=\"timeSegment in vm.timeSegments\" ng-style=\"::vm.getTimelineSegmentStyle(timeSegment)\"></span>\n" +
    "</div>");
}]);

angular.module("main/src/activity-log/bmp-timeline-cell/bmp-timeline-cell.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/activity-log/bmp-timeline-cell/bmp-timeline-cell.html",
    "<div style=\"width: 100%; height: 20px\">\n" +
    "    <span ng-repeat=\"timeSegment in vm.timeSegments\" ng-style=\"vm.getSegmentStyle(timeSegment)\"></span>\n" +
    "</div>");
}]);

angular.module("main/src/edit-multiple/edit-multiple-entry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/edit-multiple/edit-multiple-entry.html",
    "<div class=\"modal-body modal-bmWorkspace no-margin edit-multiple-wizard\">\n" +
    "\n" +
    "    <bmp-page-header is-in-modal=\"true\" header-class-fn=\"'modal-bmWorkspace-header no-margin-l'\">\n" +
    "        <bmp-page-header-left-content>\n" +
    "            <h1 translate=\"Bluemoon.TimeEntry.EditMultiple.Title\"></h1>\n" +
    "        </bmp-page-header-left-content>\n" +
    "    </bmp-page-header>\n" +
    "\n" +
    "    <div bento-wizard\n" +
    "         on-change=\"ctrl.onWizardChange(step)\"\n" +
    "         on-finish=\"ctrl.onWizardFinish()\"\n" +
    "         on-cancel=\"ctrl.onCancel(step)\"\n" +
    "         use-side-arrows=\"false\"\n" +
    "         current-step=\"step\"\n" +
    "         total-step=\"totalStep\"\n" +
    "         show-cancel-button=\"!ctrl.displayingPostSaveIssueReport\"\n" +
    "         hide-next-button=\"ctrl.displayingPostSaveIssueReport\"\n" +
    "         hide-previous-button=\"ctrl.displayingPostSaveIssueReport\">\n" +
    "        <div ng-form id=\"edit-multiple-wizard\" name=\"editMultipleWizardForm\" autocomplete=\"off\" ng-class=\"{'has-errors': ctrl.displayingPostSaveIssueReport}\">\n" +
    "\n" +
    "            <!-- Define step titles and descriptions -->\n" +
    "            <ol class=\"steps\">\n" +
    "                <li>\n" +
    "                    <span class=\"title\" translate=\"Bluemoon.TimeEntry.EditMultiple.Edit.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Bluemoon.TimeEntry.EditMultiple.Edit.Description\"></span>\n" +
    "                </li>\n" +
    "                <li ng-disabled=\"!ctrl.hasChanged() || editMultipleWizardForm.$invalid\">\n" +
    "                    <span class=\"title\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.Title\"></span>\n" +
    "                    <span class=\"description\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.Description\"></span>\n" +
    "                </li>\n" +
    "            </ol>\n" +
    "\n" +
    "            <div class=\"contents-spacer\"></div>\n" +
    "            <ul class=\"contents\">\n" +
    "                <li bento-busy-loader=\"ctrl.isBusy()\">\n" +
    "\n" +
    "                    <h1 translate=\"Bluemoon.TimeEntry.EditMultiple.Edit.Header\"></h1>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Entry Date -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.EntryDate' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"entryDate\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.EntryDate' | translate | bmRequiredMark}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-bento-datepicker-wrapper id=\"entryDate\" name=\"entryDate\"\n" +
    "                                ng-model=\"ctrl.data.entryDate.bindingValue\"\n" +
    "                                ng-required=\"!ctrl.data.entryDate.isMultipleValue\"\n" +
    "                                ng-disabled=\"ctrl.data.entryDate.isDisabled()\"\n" +
    "                                placeholder=\"{{ctrl.data.entryDate.placeholder}}\"\n" +
    "                                bmp-default-focus=\"\">\n" +
    "                            </bmp-bento-datepicker-wrapper>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.entryDate\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Staff -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Employee' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"employee\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Employee' | translate | bmRequiredMark}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"staff#active\" aotf-default name=\"employee\" required=\"true\"\n" +
    "                                            ng-model=\"ctrl.data.employee.bindingValue\"\n" +
    "                                            ng-disabled=\"ctrl.data.employee.isDisabled()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.employee\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Client -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Client' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"client\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Client' | translate | bmRequiredMark}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"clients#active#frpTimeAndExpense\" aotf-default name=\"client\" required=\"true\"\n" +
    "                                            ng-model=\"ctrl.data.client.bindingValue\"\n" +
    "                                            ng-disabled=\"ctrl.data.client.isDisabled()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.client\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Project -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"projectScheduleItem\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"project-views#frpTimeAndExpense\" aotf-default name=\"projectScheduleItem\"\n" +
    "                                            ng-model=\"ctrl.data.projectScheduleItem.bindingValue\"\n" +
    "                                            ng-disabled=\"ctrl.data.projectScheduleItem.isDisabled()\"\n" +
    "                                            filter=\"ctrl.data.projectScheduleItem.filter\"\n" +
    "                                            tooltip-placement=\"right\"\n" +
    "                                            tooltip-append-to-body=\"true\"\n" +
    "                                            data-uib-tooltip=\"{{ (ctrl.data.projectScheduleItem.isDisabled() ? 'Bluemoon.TimeEntry.EditMultiple.ProjectDisabled' : '') | translate}}\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.projectScheduleItem\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Engagement -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"engagement\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Engagement' | translate}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"client-engagements#active\" name=\"engagement\" ng-show=\"ctrl.data.engagement.context\"\n" +
    "                                            ng-model=\"ctrl.data.engagement.bindingValue\"\n" +
    "                                            ng-disabled=\"ctrl.data.engagement.isDisabled()\"\n" +
    "                                            context=\"ctrl.data.engagement.context\">\n" +
    "                            </bmp-select-combo>\n" +
    "                            <bmp-select-combo list=\"engagement-templates\" name=\"engagement\" ng-show=\"!ctrl.data.engagement.context\"\n" +
    "                                            ng-model=\"ctrl.data.engagement.bindingValue\"\n" +
    "                                            ng-disabled=\"ctrl.data.engagement.isDisabled()\"\n" +
    "                                            context=\"ctrl.data.engagement.context\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.engagement\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div bm-if-has-license=\"ProjectManagement.Tasks\">\n" +
    "                        <div class=\"row\" bm-if-perm=\"ProjectManagement.Tasks\">\n" +
    "                            <!-- Task -->\n" +
    "                            <div data-bmp-control-group=\"\"\n" +
    "                                data-bmp-control-group-field-id=\"taskScheduleItem\"\n" +
    "                                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate}}\"\n" +
    "                                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <bmp-select-combo list=\"task-views\" aotf-default name=\"taskScheduleItem\"\n" +
    "                                                ng-model=\"ctrl.data.taskScheduleItem.bindingValue\"\n" +
    "                                                filter=\"ctrl.data.taskScheduleItem.filter\"\n" +
    "                                                context=\"ctrl.data.taskScheduleItem.context\"\n" +
    "                                                ng-disabled=\"ctrl.data.taskScheduleItem.isDisabled()\"\n" +
    "                                                tooltip-placement=\"right\"\n" +
    "                                                tooltip-append-to-body=\"true\"\n" +
    "                                                data-uib-tooltip=\"{{ (ctrl.data.taskScheduleItem.isDisabled() ? 'Bluemoon.TimeEntry.EditMultiple.TaskDisabled' : '') | translate}}\">\n" +
    "                                </bmp-select-combo>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                                <time-and-expense-multiple-edit for=\"ctrl.data.taskScheduleItem\"></time-and-expense-multiple-edit>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Activity -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Activity' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"activity\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Activity' | translate | bmRequiredMark}}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <bmp-select-combo list=\"activities#active\" aotf-default name=\"activity\" required=\"true\"\n" +
    "                                            ng-model=\"ctrl.data.activity.bindingValue\"\n" +
    "                                            filter=\"ctrl.data.activity.filter\"\n" +
    "                                            ng-disabled=\"ctrl.data.activity.isDisabled()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.activity\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Hours / Units -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"hoursOrUnits\"\n" +
    "                            data-bmp-control-group-label=\"{{ctrl.data.hoursOrUnits.isDisabled() ? (ctrl.hoursOrUnitsLabel() | translate) : (ctrl.hoursOrUnitsLabel() | translate | bmRequiredMark) }}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" id=\"hoursOrUnits\" name=\"hoursOrUnits\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"ctrl.data.hoursOrUnits.bindingValue\"\n" +
    "                                data-ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                                ng-disabled=\"ctrl.data.hoursOrUnits.isDisabled()\"\n" +
    "                                ng-required=\"!ctrl.data.hoursOrUnits.isMultipleValue\"\n" +
    "                                data-bmp-big-number=\"'n2'\"\n" +
    "                                data-bmp-big-number-range-validator\n" +
    "                                bm-format-on-blur=\"\"\n" +
    "                                placeholder=\"{{ctrl.data.hoursOrUnits.placeholder}}\"\n" +
    "                                min=\"-99999.99\"\n" +
    "                                max=\"99999.99\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.hoursOrUnits\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\" bm-if-perm-some=\"['TimeAndBilling.ViewRates','TimeAndBilling.EditRates']\">\n" +
    "                        <!-- Rate -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.EmployeeBillingRate' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"employeeBillingRate\"\n" +
    "                            data-bmp-control-group-label=\"{{ctrl.data.employeeBillingRate.isDisabled() ? ('Core.Captions.TimeAndExpense.EmployeeBillingRate' | translate) : ('Core.Captions.TimeAndExpense.EmployeeBillingRate' | translate | bmRequiredMark) }}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\" ng-switch=\"ctrl.data.employeeBillingRate.isDisabled() || !ctrl.hasEditRatesPermission\">\n" +
    "                            <!-- Have to switch between them to enable/disable preserving the required attribute correctly -->\n" +
    "                            <bmp-enum-combo enum=\"custom\" name=\"employeeBillingRate\"\n" +
    "                                            custom-items=\"ctrl.data.employeeBillingRate.availableValues\"\n" +
    "                                            ng-model=\"ctrl.data.employeeBillingRate.bindingValue\"\n" +
    "                                            ng-switch-when=\"true\"\n" +
    "                                            ng-disabled=\"ctrl.data.employeeBillingRate.isDisabled()\"\n" +
    "                                            ng-readonly=\"!ctrl.hasEditRatesPermission\"\n" +
    "                                            tooltip-placement=\"right\"\n" +
    "                                            tooltip-append-to-body=\"true\"\n" +
    "                                            data-uib-tooltip=\"{{ (ctrl.data.employeeBillingRate.isDisabled() ? 'Bluemoon.TimeEntry.EditMultiple.RateDisabled' : '') | translate}}\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                            <bmp-enum-combo enum=\"custom\" name=\"employeeBillingRate\"\n" +
    "                                            custom-items=\"ctrl.data.employeeBillingRate.availableValues\"\n" +
    "                                            ng-model=\"ctrl.data.employeeBillingRate.bindingValue\"\n" +
    "                                            ng-switch-when=\"false\"\n" +
    "                                            required=\"true\">\n" +
    "                            </bmp-enum-combo>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.employeeBillingRate\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\" bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "                        <!-- Unit Price -->\n" +
    "                        <!-- /* i18nextract */'Core.Captions.TimeAndExpense.UnitPrice -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"unitPrice\"\n" +
    "                            data-bmp-control-group-label=\"{{ctrl.data.unitPrice.isDisabled() ? ('Core.Captions.TimeAndExpense.UnitPrice' | translate) : ('Core.Captions.TimeAndExpense.UnitPrice' | translate | bmRequiredMark) }}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <div data-uib-tooltip=\"{{ (ctrl.data.unitPrice.isDisabled() ? 'Bluemoon.TimeEntry.EditMultiple.UnitPriceDisabled' : '') | translate}}\"\n" +
    "                                tooltip-placement=\"right\"\n" +
    "                                tooltip-append-to-body=\"true\">\n" +
    "                                <input autocomplete=\"off\" type=\"text\" id=\"unitPrice\" name=\"unitPrice\"\n" +
    "                                    class=\"form-control\"\n" +
    "                                    data-ng-model=\"ctrl.data.unitPrice.bindingValue\"\n" +
    "                                    data-ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                                    ng-disabled=\"ctrl.data.unitPrice.isDisabled()\"\n" +
    "                                    ng-readonly=\"!ctrl.hasEditAmountsPermission\"\n" +
    "                                    ng-required=\"!ctrl.data.unitPrice.isMultipleValue && !ctrl.data.unitPrice.isDisabled() && ctrl.hasEditAmountsPermission\"\n" +
    "                                    data-bmp-big-number=\"'c4'\"\n" +
    "                                    data-bmp-big-number-range-validator=\"\"\n" +
    "                                    bm-format-on-blur=\"\"\n" +
    "                                    placeholder=\"{{ctrl.data.unitPrice.placeholder}}\"\n" +
    "                                    min=\"0\"\n" +
    "                                    max=\"99999.9999\" />\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.unitPrice\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\" bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "                        <!-- Amount -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"amount\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Amount' | translate }}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'amount')\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "\n" +
    "                            <input autocomplete=\"off\" type=\"text\" id=\"amount\" name=\"amount\" readonly=\"readonly\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"ctrl.data.amount.bindingValue\"\n" +
    "                                data-ng-model-options=\"{ updateOn: 'blur', allowInvalid: true }\"\n" +
    "                                data-bmp-big-number=\"'c2'\"\n" +
    "                                data-bmp-big-number-range-validator\n" +
    "                                bm-format-on-blur=\"\"\n" +
    "                                min=\"ctrl.minAmount\"\n" +
    "                                max=\"ctrl.maxAmount\"\n" +
    "                                data-bmp-control-group-field=\"Core.Captions.TimeAndExpense.Amount\"\n" +
    "                                ng-disabled=\"ctrl.data.amount.isDisabled()\"\n" +
    "                                ng-readonly=\"!ctrl.hasEditAmountsPermission\"\n" +
    "                                placeholder=\"{{ctrl.data.amount.placeholder}}\"\n" +
    "                                 />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.amount\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Comment -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"comment\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Comment' | translate }}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" id=\"comment\" name=\"comment\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"ctrl.data.comment.bindingValue\"\n" +
    "                                data-ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                                ng-disabled=\"ctrl.data.comment.isDisabled()\"\n" +
    "                                placeholder=\"{{ctrl.data.comment.placeholder}}\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.comment\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <!-- Biller note -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"billerNote\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.BillerNote' | translate }}\"\n" +
    "                            class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <input autocomplete=\"off\" type=\"text\" id=\"billerNote\" name=\"billerNote\"\n" +
    "                                class=\"form-control\"\n" +
    "                                data-ng-model=\"ctrl.data.billerNote.bindingValue\"\n" +
    "                                data-ng-model-options=\"{ updateOn: 'blur' }\"\n" +
    "                                ng-disabled=\"ctrl.data.billerNote.isDisabled()\"\n" +
    "                                placeholder=\"{{ctrl.data.billerNote.placeholder}}\" />\n" +
    "                        </div>\n" +
    "                        <div class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                            <time-and-expense-multiple-edit for=\"ctrl.data.billerNote\"></time-and-expense-multiple-edit>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "\n" +
    "                <li bento-busy-loader=\"ctrl.isBusy()\">\n" +
    "\n" +
    "                    <div style=\"margin: 20px 0px; width: 50%;\" ng-if=\"ctrl.displayingPostSaveIssueReport\">\n" +
    "                        <div class=\"alert alert-warning\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.SaveWarning\" translate-values=\"{ count: ctrl.saveWarnings().length }\" translate-interpolation=\"messageformat\" ng-if=\"ctrl.showSaveWarning()\"></div>\n" +
    "                        <div class=\"alert alert-danger\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.SaveError\" translate-values=\"{ count: ctrl.saveErrors().length }\" translate-interpolation=\"messageformat\" ng-if=\"ctrl.showSaveError()\"></div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <h1 translate=\"Bluemoon.TimeEntry.EditMultiple.Review.Header\" ng-hide=\"ctrl.displayingPostSaveIssueReport\"></h1>\n" +
    "\n" +
    "                    <div class=\"alert alert-warning\" style=\"width: 50%;\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.ProjectWarning\" ng-if=\"ctrl.showProjectWarning()\" ng-hide=\"ctrl.displayingPostSaveIssueReport\"></div>\n" +
    "                    <div class=\"alert alert-warning\" style=\"width: 50%;\" translate=\"Bluemoon.TimeEntry.EditMultiple.Review.EngagementWarning\" ng-if=\"ctrl.showEngagementWarning()\" ng-hide=\"ctrl.displayingPostSaveIssueReport\"></div>\n" +
    "\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-md-12\">\n" +
    "                            <h5 translate=\"Bluemoon.TimeEntry.EditMultiple.Review.Changes\"></h5>\n" +
    "                            <div class=\"selected-changes\">\n" +
    "                                <div ng-repeat=\"property in ctrl.properties\" ng-if=\"property.hasChanged && ctrl.getDisplayValue(property.bindingValue) !== ctrl.getDisplayValue(property.mergedValue)\">\n" +
    "                                    {{property.name}}: {{ctrl.getDisplayValue(property.bindingValue)}}\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                            <div class=\"toggle-grid-container\" ng-hide=\"ctrl.displayingPostSaveIssueReport\">\n" +
    "                                <span translate=\"Bluemoon.TimeEntry.EditMultiple.Review.SelectedChanges\" translate-values=\"{ count: ctrl.items.length}\"></span>\n" +
    "                                <div class=\"toggle-grid-button\">\n" +
    "                                    <a ng-click=\"wizard_show_details = !wizard_show_details\">\n" +
    "                                        <span ng-show=\"!wizard_show_details\" translate=\"Bluemoon.Core.Setup.ShowDetails\"></span>\n" +
    "                                        <span ng-show=\"wizard_show_details\" translate=\"Bluemoon.Core.Setup.HideDetails\"></span>\n" +
    "                                    </a>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div class=\"col-md-12 review-grid-container\" ng-if=\"wizard_show_details || ctrl.displayingPostSaveIssueReport\">\n" +
    "                            <div bento-toolbar class=\"navbar navbar-default bento-toolbar\" ng-if=\"ctrl.displayingPostSaveIssueReport\"\n" +
    "                                toolbar-data=\"ctrl.toolbarButtons\"></div>\n" +
    "                            <wj-flex-grid class=\"bento-flex-grid\"\n" +
    "                                bmp-set-height=\"\"\n" +
    "                                bmp-set-height-fill-vertical-height=\"true\"\n" +
    "                                bmp-set-height-fill-vertical-height-other-height=\"bmpWijmoTableFillVerticalHeightOtherHeight\"\n" +
    "                                bmp-set-height-min-height=\"200\"\n" +
    "                                bmp-set-height-max-height=\"1000\"\n" +
    "                                is-read-only=\"true\"\n" +
    "                                items-source=\"ctrl.gridItems\"\n" +
    "                                loaded-rows=\"ctrl.loadedRows(s,e)\">\n" +
    "                                <wj-flex-grid-column ng-if=\"ctrl.displayingPostSaveIssueReport\" name=\"issue\" header=\"\" binding=\"\" width=\"75\" align=\"center\">\n" +
    "                                    <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                                        <span>\n" +
    "                                            <a data-qe-id=\"error-icon\" ng-if=\"ctrl.hasError($row.dataItem)\" class=\"bmp-wijmo-table-actions-column-icon-item error-icon\">\n" +
    "                                                <span\n" +
    "                                                    class=\"bento-icon-warning\"\n" +
    "                                                    data-tooltip-placement=\"top\"\n" +
    "                                                    data-tooltip-trigger=\"mouseenter\"\n" +
    "                                                    data-uib-tooltip=\"{{$row.dataItem.issues[0].error}}\"\n" +
    "                                                    data-tooltip-append-to-body=\"true\">\n" +
    "                                                </span>\n" +
    "                                            </a>\n" +
    "                                            <a data-qe-id=\"warning-icon\" ng-if=\"ctrl.hasWarning($row.dataItem)\" class=\"bmp-wijmo-table-actions-column-icon-item warning-icon\">\n" +
    "                                                    <span\n" +
    "                                                        class=\"bento-icon-warning-round\"\n" +
    "                                                        data-tooltip-placement=\"top\"\n" +
    "                                                        data-tooltip-trigger=\"mouseenter\"\n" +
    "                                                        data-uib-tooltip=\"{{ctrl.saveWarningMessages($row.dataItem)}}\"\n" +
    "                                                        data-tooltip-append-to-body=\"true\">\n" +
    "                                                    </span>\n" +
    "                                                </a>\n" +
    "                                        </span>\n" +
    "                                    </wj-flex-grid-cell-template>\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column header=\"{{ 'Core.Captions.TimeAndExpense.EntryDate' | translate }}\"\n" +
    "                                    binding=\"entryDate\"\n" +
    "                                    width=\"*\">{{ctrl.formatDate($item.entryDate)}}\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.Contact.EmployeeCode' | translate }}\"\n" +
    "                                    binding=\"employee.code\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.Contact.ClientCode' | translate }}\"\n" +
    "                                    binding=\"client.code\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header= \"{{ 'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\"\n" +
    "                                    binding=\"projectScheduleItem.name\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Bluemoon.TimeEntry.Review.EngagementIdColumn' | translate }}\"\n" +
    "                                    binding=\"engagement.code\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate }}\"\n" +
    "                                    binding=\"taskScheduleItem.name\"\n" +
    "                                    width=\"*\"\n" +
    "                                    ng-if=\"ctrl.hasTaskPermissions()\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Bluemoon.TimeEntry.Review.ActivityIdColumn' | translate }}\"\n" +
    "                                    binding=\"activity.code\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ ctrl.hoursLabelKey | translate }}\"\n" +
    "                                    binding=\"hours\"\n" +
    "                                    align=\"right\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.Units' | translate }}\"\n" +
    "                                    binding=\"units\"\n" +
    "                                    align=\"right\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.EmployeeBillingRate' | translate }}\"\n" +
    "                                    binding=\"employeeBillingRate.name\"\n" +
    "                                    width=\"*\"\n" +
    "                                    bm-if-perm-some=\"['TimeAndBilling.ViewRates','TimeAndBilling.EditRates']\">{{ctrl.formatRate($item.employeeBillingRate)}}\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.UnitPrice' | translate }}\"\n" +
    "                                    binding=\"unitPrice\"\n" +
    "\n" +
    "                                    align=\"right\"\n" +
    "                                    width=\"*\"\n" +
    "                                    bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">{{ctrl.formatUnitPrice($item)}}\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.Comment' | translate }}\"\n" +
    "                                    binding=\"comment\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                                <wj-flex-grid-column\n" +
    "                                    header=\"{{ 'Core.Captions.TimeAndExpense.BillerNote' | translate }}\"\n" +
    "                                    binding=\"billerNote\"\n" +
    "                                    width=\"*\">\n" +
    "                                </wj-flex-grid-column>\n" +
    "                            </wj-flex-grid>\n" +
    "                        </div>\n" +
    "\n" +
    "                    </div>\n" +
    "                </li>\n" +
    "            </ul>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/edit-multiple/edit-multiple-field.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/edit-multiple/edit-multiple-field.html",
    "<a class=\"undo-button\" ng-show=\"for.hasUserChanged\" data-uib-tooltip=\"{{'Bluemoon.TimeEntry.EditMultiple.RevertToOriginal' | translate}}\"\n" +
    "        tooltip-placement=\"right\" ng-click=\"for.revertChanges()\">\n" +
    "        <i class=\"bento-icon-undo revert-changes\"></i>\n" +
    "</a>\n" +
    "");
}]);

angular.module("main/src/entry/daily-entry/time-and-expense-daily-entry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/daily-entry/time-and-expense-daily-entry.html",
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-4\">\n" +
    "        <div style=\"display: flex; flex-direction: column\">\n" +
    "            <time-and-expense-entry-form\n" +
    "                time-and-expense-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "                time-and-expense-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id, previousIdSaved)\"\n" +
    "                time-and-expense-entry-form-employee=\"vm.employee\"\n" +
    "                time-and-expense-entry-form-allow-new=\"true\"\n" +
    "                time-and-expense-entry-form-use-timers-layout=\"false\"\n" +
    "                time-and-expense-entry-form-analytics-context=\"practice_timeAndExpense_dailyEntry\">\n" +
    "            </time-and-expense-entry-form>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"col-md-8\">\n" +
    "        <h3 class=\"no-top-margin\" data-qe-id=\"bm-TAndE-summary-header\">{{'Bluemoon.TimeAndExpense.DailyEntry.Summary' | translate}}</h3>\n" +
    "        <time-and-expense-recap\n" +
    "            time-and-expense-recap-edit-item=\"vm.editItem(id)\"\n" +
    "            time-and-expense-recap-activity-type=\"vm.entryFormController.activityType\"\n" +
    "            time-and-expense-recap-employee=\"vm.employee\"\n" +
    "            time-and-expense-recap-date-filter=\"vm.dateFilter\">\n" +
    "        </time-and-expense-recap>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/entry/daily-entry/time-and-expense-recap/time-and-expense-recap.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/daily-entry/time-and-expense-recap/time-and-expense-recap.html",
    "<div class=\"bmp-summary-blocks\">\n" +
    "    <div class=\"row\" ng-show=\"vm.activityType.id === 'TIME'\">\n" +
    "        <!--TIME RECAP SUMMARY-->\n" +
    "        <div class=\"col-xs-3\">{{'Bluemoon.TimeEntry.TimeRecap.Summary.BillableLabel' | translate }} <p>{{vm.summary.TIME.billable}}</p></div>\n" +
    "        <div class=\"col-xs-3\">{{'Bluemoon.TimeEntry.TimeRecap.Summary.NonbillableLabel' | translate }} <p>{{vm.summary.TIME.nonbillable}}</p></div>\n" +
    "        <div class=\"col-xs-3\">{{'Bluemoon.TimeEntry.TimeRecap.Summary.AdministrativeLabel' | translate }} <p>{{vm.summary.TIME.administrative}}</p></div>\n" +
    "        <div class=\"col-xs-3\">{{'Bluemoon.TimeEntry.TimeRecap.Summary.TotalLabel' | translate }} <p>{{vm.summary.TIME.total}}</p></div>\n" +
    "    </div>\n" +
    "    <div class=\"row\" ng-show=\"vm.activityType.id === 'EXPENSE'\">\n" +
    "        <!--EXPENSE RECAP SUMMARY-->\n" +
    "        <div class=\"col-xs-6\">{{'Bluemoon.TimeEntry.ExpenseRecap.Summary.TotalUnitsLabel' | translate }} <p>{{vm.summary.EXPENSE.expenseUnits}}</p></div>\n" +
    "        <div class=\"col-xs-6\">{{'Bluemoon.TimeEntry.ExpenseRecap.Summary.TotalAmountLabel' | translate }} <p>{{vm.summary.EXPENSE.total}}</p></div>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.currentItemCount >= 200\"><em><small>{{'Bluemoon.TimeEntry.TimeRecap.ItemLimitWarning' | translate }}</small></em></div>\n" +
    "</div>\n" +
    "<div class=\"well bm-well bmp-summary-blocks-detail\" bento-busy-loader=\"vm.loadPromise\">\n" +
    "    <!--TIME RECAP GRID-->\n" +
    "    <div> <!-- We don't want a throbber here, b/c it doesn't look good (the daily entry screen and the grid doesn't load at the same time) -->\n" +
    "        <wj-flex-grid ng-show=\"vm.activityType.id === 'TIME'\" control=\"vm.timeFlexGrid\" items-source=\"vm.data.TIME\" class=\"bento-flex-grid\" headers-visibility=\"Column\"\n" +
    "                    selection-mode=\"None\"\n" +
    "                    item-formatter=\"itemFormatter\"\n" +
    "                    is-read-only=\"true\" items-source-changed=\"vm.itemsSourceChanged(s,e)\"\n" +
    "                    group-header-format=\"<b>{value}</b> ({count:n0} items)\">\n" +
    "            <wj-flex-grid-column header=\"\" binding=\"\" min-width=\"55\" width=\"55\" align=\"left\" is-read-only=\"true\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                    <span class=\"bento-icon-edit grid-action-icon\" ng-click=\"vm.selectRow($item, $row)\" data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{ 'Bluemoon.Practice.Common.Actions.Edit' | translate }}\"  data-tooltip-append-to-body=\"true\">\n" +
    "                    </span>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.EntryDate' | translate }}\" binding=\"entryDate\" visible=\"false\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.Client' | translate }}\" binding=\"client.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\" binding=\"projectScheduleItem.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Bluemoon.TimeEntry.Review.EngagementIdColumn' | translate }}\" binding=\"engagement.code\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate }}\" binding=\"taskScheduleItem.name\" ng-if=\"vm.hasTaskPermissions()\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Bluemoon.TimeEntry.Review.ActivityIdColumn' | translate }}\" binding=\"activity.code\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"80\" header=\"{{ vm.getHoursLabelKey(vm.userPreferences.timeEntryStyle.id) | translate }}\" binding=\"$hours\" align=\"right\" aggregate=\"Sum\" format=\"N2\" visible=\"{{vm.activityType.id === 'TIME'}}\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"100\" header=\"{{ 'Core.Captions.TimeAndExpense.Amount' | translate }}\" binding=\"amount\" align=\"right\" aggregate=\"Sum\" format=\"C2\" bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "                    <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                        <span ng-if=\"$item.amountIsOverridden\" ng-class=\"'bmp-wijmo-table-info-icon-align-left'\"\n" +
    "                        class=\"bento-icon-info bmp-wijmo-table-info-icon\"\n" +
    "                        data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{'Core.Captions.TimeAndExpense.AmountIsOverridden' | translate }}\" data-tooltip-append-to-body=\"true\"></span>\n" +
    "                        <div>{{vm.formatNumber($item.amount, 'c2')}}</div>\n" +
    "                    </wj-flex-grid-cell-template>\n" +
    "                </wj-flex-grid-column>\n" +
    "        </wj-flex-grid>\n" +
    "        <!--EXPENSE RECAP GRID-->\n" +
    "        <wj-flex-grid ng-show=\"vm.activityType.id === 'EXPENSE'\" control=\"vm.expenseFlexGrid\" items-source=\"vm.data.EXPENSE\" class=\"bento-flex-grid\" headers-visibility=\"Column\"\n" +
    "                    selection-mode=\"None\"\n" +
    "                    item-formatter=\"itemFormatter\"\n" +
    "                    is-read-only=\"true\" items-source-changed=\"vm.itemsSourceChanged(s,e)\"\n" +
    "                    group-header-format=\"<b>{value}</b> ({count:n0} items)\">\n" +
    "            <wj-flex-grid-column header=\"\" binding=\"\" min-width=\"55\" width=\"55\" align=\"left\" is-read-only=\"true\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                    <span class=\"bento-icon-edit grid-action-icon\" ng-click=\"vm.selectRow($item, $row)\" data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{ 'Bluemoon.Practice.Common.Actions.Edit' | translate }}\"  data-tooltip-append-to-body=\"true\">\n" +
    "                    </span>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "            </wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.EntryDate' | translate }}\" binding=\"entryDate\" visible=\"false\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.Client' | translate }}\" binding=\"client.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\" binding=\"projectScheduleItem.name\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Bluemoon.TimeEntry.Review.EngagementIdColumn' | translate }}\" binding=\"engagement.code\"></wj-flex-grid-column>\n" +
    "            <div bm-if-has-license=\"ProjectManagement.Tasks\">\n" +
    "                <wj-flex-grid-column width=\"2*\" header=\"{{ 'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate }}\" binding=\"taskScheduleItem.name\" bm-if-perm=\"ProjectManagement.Tasks\"></wj-flex-grid-column>\n" +
    "            </div>\n" +
    "            <wj-flex-grid-column width=\"2*\" header=\"{{ 'Bluemoon.TimeEntry.Review.ActivityIdColumn' | translate }}\" binding=\"activity.code\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"80\" header=\"{{ 'Core.Captions.TimeAndExpense.Units' | translate }}\" binding=\"expenseUnits\" align=\"right\" aggregate=\"Sum\" format=\"N2\" visible=\"{{vm.activityType.id === 'EXPENSE'}}\"></wj-flex-grid-column>\n" +
    "            <wj-flex-grid-column width=\"100\" header=\"{{ 'Core.Captions.TimeAndExpense.Amount' | translate }}\" binding=\"amount\" align=\"right\" aggregate=\"Sum\" format=\"C2\" bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "                <wj-flex-grid-cell-template cell-type=\"Cell\">\n" +
    "                    <span ng-if=\"$item.amountIsOverridden\" ng-class=\"'bmp-wijmo-table-info-icon-align-left'\"\n" +
    "                    class=\"bento-icon-info bmp-wijmo-table-info-icon\"\n" +
    "                    data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{'Core.Captions.TimeAndExpense.AmountIsOverridden' | translate }}\" data-tooltip-append-to-body=\"true\"></span>\n" +
    "                    <div>{{vm.formatNumber($item.amount, 'c2')}}</div>\n" +
    "                </wj-flex-grid-cell-template>\n" +
    "            </wj-flex-grid-column>\n" +
    "        </wj-flex-grid>\n" +
    "    </div>\n" +
    "    <div ng-show=\"vm.currentItemCount >= 200\"><em><small>{{'Bluemoon.TimeEntry.TimeRecap.ItemLimitWarning' | translate }}</small></em></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/entry/entry-form/time-and-expense-entry-form.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/entry-form/time-and-expense-entry-form.html",
    "<ng-form id=\"timeAndExpenseEntryForm\" name=\"vm.timeAndExpenseEntryForm\">\n" +
    "<div ng-hide=\"!vm.hasData()\" id=\"bm-timeAndExpense-entry-form\" bento-busy-loader=\"vm.detail.isLoadingData()\" bento-busy-loader-size=\"small\"\n" +
    "    bmp-detail-view-default-focus=\"vm.data\"\n" +
    "    bmp-detail-view-default-focus-focus-on-event=\"TimeAndExpenseEntryForm-AfterLoad\">\n" +
    "    <fieldset data-ng-disabled=\"vm.isFormReadOnly()\">\n" +
    "        <div class=\"row\" ng-if=\"vm.useTimersLayout\">\n" +
    "            <div class=\"col-xs-12\">\n" +
    "                <div class=\"bmp-summary-blocks entry-form-summary-blocks\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <div class=\"col-xs-6\" data-qe-id=\"bm-timer-detailStartDate-label\">\n" +
    "                            {{'Bluemoon.TimeEntry.Timer.TimerDetail.StartDateHeader' | translate }}\n" +
    "                            <p>{{vm.startDate() | timeOfDay}}</p>\n" +
    "                        </div>\n" +
    "                        <div class=\"col-xs-6\" data-qe-id=\"bm-timer-detailAccumulatedTime-label\">\n" +
    "                            {{'Bluemoon.TimeEntry.Timer.TimerDetail.TotalTimeHeader' | translate }}\n" +
    "                            <p>{{vm.totalTime() | timespan}}</p>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::!vm.useTimersLayout\">\n" +
    "            <!-- Sheet Date -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.TimeAndExpense.SheetDate' -->\n" +
    "            <!--\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"sheetDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.SheetDate' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'sheetDate')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"timeAndExpense.sheetDate\"\n" +
    "                                            ng-model=\"vm.data.sheetDate\"\n" +
    "                                            name=\"sheetDate\"\n" +
    "                                            data-ng-required=\"true\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div> -->\n" +
    "            <!-- Entry Date -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.TimeAndExpense.EntryDate' -->\n" +
    "            <div ng-if=\"!vm.userPrefData.entryDateHide\" data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"entryDate\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.EntryDate' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'entryDate')\"\n" +
    "                class=\"col-md-6 col-sm-6 col-xs-12\">\n" +
    "                <bmp-bento-datepicker-wrapper id=\"timeAndExpense.entryDate\"\n" +
    "                                            ng-model=\"vm.data.entryDate\"\n" +
    "                                            name=\"entryDate\"\n" +
    "                                            data-ng-required=\"true\"\n" +
    "                                            data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                            bmp-bento-datepicker-wrapper-tab-stop=\"!vm.userPrefData.entryDateSkip\">\n" +
    "                </bmp-bento-datepicker-wrapper>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"vm.showStaffControl\">\n" +
    "            <!-- Staff -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Employee' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"employee\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Employee' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'employee')\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <bmp-select-combo list=\"staff#active\" aotf-default\n" +
    "                                name=\"employee\"\n" +
    "                                ng-model=\"vm.data.employee\"\n" +
    "                                required=\"true\"\n" +
    "                                data-ng-disabled=\"vm.isFormReadOnly()\">\n" +
    "                </bmp-select-combo>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\" class=\"col-xs-12\">\n" +
    "                <!-- Client -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Client' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"client\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Client' | translate | bmRequiredMark:!vm.useTimersLayout}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'client')\">\n" +
    "                    <bmp-select-combo list=\"clients#active#frpTimeAndExpense\"\n" +
    "                                    name=\"client\"\n" +
    "                                    ng-model=\"vm.data.$client\"\n" +
    "                                    ng-required=\"vm.entryFormType === 0\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    on-change=\"vm.onClientChange()\"\n" +
    "                                    aotf=\"vm.clientAotf\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div class=\"col-xs-6\">\n" +
    "                <!-- Project -->\n" +
    "                <div ng-if=\"!vm.userPrefData.projectHide\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"projectScheduleItem\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.ProjectScheduleItem' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'projectScheduleItem')\">\n" +
    "                    <bmp-select-combo list=\"project-views#frpTimeAndExpense\"\n" +
    "                                    name=\"projectScheduleItem\"\n" +
    "                                    ng-model=\"vm.data.$projectScheduleItem\"\n" +
    "                                    filter=\"vm.projectComboFilter()\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    aotf=\"vm.projectAotf\"\n" +
    "                                    data-bmp-tab-stop=\"!vm.userPrefData.projectSkip\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-xs-6\" ng-if=\"vm.entryFormType === 0 || vm.entryFormType === 3\">\n" +
    "                <!-- Project Tracking Description -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.TimeEntry.DailyEntry.Tracking' -->\n" +
    "                <div ng-if=\"!vm.userPrefData.projectHide\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"projectTrackingDescription\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.DailyEntry.Tracking' | translate | bmRequiredMark:vm.hasProject()}}\"\n" +
    "                    data-bmp-control-group-error=\"ctrl.detail.errorFor(vm.data, 'projectTrackingDescription')\">\n" +
    "                    <bmp-select-combo list=\"tracking-descriptions\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    name=\"projectTrackingDescription\"\n" +
    "                                    ng-model=\"vm.domain.project.trackingDescription\"\n" +
    "                                    filter=\"\"\n" +
    "                                    on-change=\"vm.projectTrackingDescriptionChanged()\"\n" +
    "                                    data-ng-disabled=\"!vm.data.$projectScheduleItem\"\n" +
    "                                    data-bmp-tab-stop=\"!vm.userPrefData.projectSkip\"\n" +
    "                                    ng-required=\"vm.hasProject()\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div bm-if-has-license=\"ProjectManagement.Tasks\">\n" +
    "                <div bm-if-perm=\"ProjectManagement.Tasks\">\n" +
    "                    <div class=\"col-xs-6\">\n" +
    "                        <!-- Task -->\n" +
    "                        <div ng-if=\"!vm.userPrefData.taskHide\"\n" +
    "                            data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"taskScheduleItem\"\n" +
    "                            data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.TaskScheduleItem' | translate }}\"\n" +
    "                            data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'taskScheduleItem')\">\n" +
    "                            <bmp-select-combo list=\"task-views#STAFF\" aotf-default\n" +
    "                                            name=\"taskScheduleItem\"\n" +
    "                                            ng-model=\"vm.data.$taskScheduleItem\"\n" +
    "                                            context=\"vm.getTaskContext()\"\n" +
    "                                            filter=\"vm.taskComboFilter()\"\n" +
    "                                            data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                            data-bmp-tab-stop=\"!vm.userPrefData.taskSkip\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-xs-6\" ng-if=\"vm.entryFormType === 0 || vm.entryFormType === 3\">\n" +
    "                        <!-- Task Tracking Description -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.TimeEntry.DailyEntry.Tracking' -->\n" +
    "                        <div  ng-if=\"!vm.userPrefData.taskHide\"\n" +
    "                            data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"taskTrackingDescription\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.DailyEntry.Tracking' | translate | bmRequiredMark:vm.hasTask()}}\"\n" +
    "                            data-bmp-control-group-error=\"ctrl.detail.errorFor(vm.data, 'taskTrackingDescription')\">\n" +
    "                            <bmp-select-combo list=\"tracking-descriptions\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            name=\"taskTrackingDescription\"\n" +
    "                                            ng-model=\"vm.domain.task.trackingDescription\"\n" +
    "                                            filter=\"\"\n" +
    "                                            data-ng-disabled=\"vm.taskTrackingComboDisabled()\"\n" +
    "                                            data-bmp-tab-stop=\"!vm.userPrefData.taskSkip\"\n" +
    "                                            ng-required=\"vm.hasTask()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\">\n" +
    "                <!-- Engagement -->\n" +
    "                <div ng-if=\"!vm.userPrefData.engagementTemplateHide\" data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"engagement\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Engagement' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'engagement')\">\n" +
    "                    <bmp-select-combo list=\"client-engagements#active\"\n" +
    "                                    name=\"engagement\"\n" +
    "                                    ng-model=\"vm.data.$engagement\"\n" +
    "                                    context=\"vm.data.client.id\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    data-bmp-tab-stop=\"!vm.userPrefData.engagementTemplateSkip\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\" class=\"col-xs-12\">\n" +
    "                <!-- Activity -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Activity' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"activity\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Activity' | translate | bmRequiredMark:!vm.useTimersLayout}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activity')\">\n" +
    "                    <bmp-select-combo list=\"activities#active\"\n" +
    "                                    aotf-default\n" +
    "                                    name=\"activity\"\n" +
    "                                    ng-model=\"vm.data.$activity\"\n" +
    "                                    ng-required=\"vm.entryFormType === 0\"\n" +
    "                                    filter=\"vm.activityComboFilter()\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    on-change=\"vm.onActivityChange()\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "                <div class=\"predictive-time-entry\" bm-if-perm=\"TimeAndBilling.PredictiveTimeEntry\">\n" +
    "                    <div class=\"col-sm-6 col-xs-6 inline-item\" style=\" margin-top: -9px;\">\n" +
    "                        <div ng-if=\"vm.isPredictiveActivitySelected\">\n" +
    "                            <div ng-if=\"vm.predictionAutoResult === 'Very confident'\">\n" +
    "                                <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"padding-top:5px;\"\n" +
    "                                    width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                    preserveAspectRatio=\"xMidYMid meet\">\n" +
    "\n" +
    "                                    <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n" +
    "                                        <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                                           0 -20 -7 -20 -65z\" />\n" +
    "                                        <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                                           -20 -7 -20 -45z\" />\n" +
    "                                        <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                                           -20 -7 -20 -30z\" />\n" +
    "                                    </g>\n" +
    "                                </svg> <label style=\"margin-left: 3px;\">{{vm.predictionAutoResult }}</label>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"vm.predictionAutoResult === 'Somewhat confident'\">\n" +
    "                                <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"padding-top:5px\"\n" +
    "                                    width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                    preserveAspectRatio=\"xMidYMid meet\">\n" +
    "                                    <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n" +
    "                                        <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                                        0 -20 -7 -20 -65z m30 0 c0 -30 -4 -55 -10 -55 -5 0 -10 25 -10 55 0 30 5 55\n" +
    "                                                                        10 55 6 0 10 -25 10 -55z\" />\n" +
    "                                        <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                                        -20 -7 -20 -45z m30 0 c0 -19 -4 -35 -10 -35 -5 0 -10 16 -10 35 0 19 5 35 10\n" +
    "                                                                        35 6 0 10 -16 10 -35z\" />\n" +
    "                                        <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                                        -20 -7 -20 -30z\" />\n" +
    "                                    </g>\n" +
    "                                </svg> <label style=\"margin-left: 3px;\">{{vm.predictionAutoResult }}</label>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"vm.predictionAutoResult === 'Confident'\">\n" +
    "                                <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"padding-top:5px\"\n" +
    "                                    width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                    preserveAspectRatio=\"xMidYMid meet\">\n" +
    "\n" +
    "                                    <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\" stroke=\"none\">\n" +
    "                                        <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                0 -20 -7 -20 -65z m30 0 c0 -30 -4 -55 -10 -55 -5 0 -10 25 -10 55 0 30 5 55\n" +
    "                                                10 55 6 0 10 -25 10 -55z\" />\n" +
    "                                        <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                -20 -7 -20 -45z\" />\n" +
    "                                        <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                -20 -7 -20 -30z\" />\n" +
    "                                    </g>\n" +
    "                                </svg> <label style=\"margin-left: 3px;\">{{vm.predictionAutoResult }}</label>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"vm.predictionAutoResult === 'AI suggested'\">\n" +
    "                                <i class=\"bento-icon-info\" style=\"padding-top:5px\"></i>\n" +
    "                                <label style=\"margin-left: 5px;\">{{vm.predictionAutoResult }}</label>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-sm-6 col-xs-6 inline-item\">\n" +
    "                        <bmp-modal bmp-modal-save=\"vm.modalSaveClicked()\" bmp-modal-cancel=\"vm.modalCancelClicked()\">\n" +
    "                            <bmp-modal-button style=\"color:#0072a8;\" data-ng-click=\"vm.predictions()\">\n" +
    "                                <span style=\"float: right;margin-top: -9px;\" translate=\"Bluemoon.TimeEntry.Activity.Prediction\"></span>\n" +
    "                            </bmp-modal-button>\n" +
    "                            <bmp-modal-header>\n" +
    "                                <h2 data-qe-id=\"header-title\">{{'Bluemoon.TimeEntry.Activity.Prediction.Header' | translate }}</h2>\n" +
    "                            </bmp-modal-header>\n" +
    "                            <bmp-modal-content class=\"bmp-slideout-filter-panel-select-modal-content\"\n" +
    "                                ng-repeat=\"data in vm.predictionResult.items\">\n" +
    "                                <input type=\"radio\" name=\"confidenceLevel\" data-ng-model=\"vm.radioButtonData\" value=\"{{data.id}}\">\n" +
    "                                <label style=\"margin-left: 4px;font-size: 16px;\">{{data.name}}</label><br>\n" +
    "                                <div ng-if=\"data.activityPredictionLevelType.name === 'Very confident'\">\n" +
    "                                    <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-left: 19px; padding-top:5px;\"\n" +
    "                                        width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                        preserveAspectRatio=\"xMidYMid meet\">\n" +
    "\n" +
    "                                        <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\"\n" +
    "                                            stroke=\"none\">\n" +
    "                                            <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                                                   0 -20 -7 -20 -65z\" />\n" +
    "                                            <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                                                   -20 -7 -20 -45z\" />\n" +
    "                                            <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                                                   -20 -7 -20 -30z\" />\n" +
    "                                        </g>\n" +
    "                                    </svg> <label style=\"margin-left: 3px;\">{{data.activityPredictionLevelType.name}}</label><br>\n" +
    "                                </div>\n" +
    "                                <div ng-if=\"data.activityPredictionLevelType.name === 'Somewhat confident'\">\n" +
    "                                    <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-left: 19px; padding-top:5px\"\n" +
    "                                        width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                        preserveAspectRatio=\"xMidYMid meet\">\n" +
    "                                        <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\"\n" +
    "                                            stroke=\"none\">\n" +
    "                                            <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                                                0 -20 -7 -20 -65z m30 0 c0 -30 -4 -55 -10 -55 -5 0 -10 25 -10 55 0 30 5 55\n" +
    "                                                                                10 55 6 0 10 -25 10 -55z\" />\n" +
    "                                            <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                                                -20 -7 -20 -45z m30 0 c0 -19 -4 -35 -10 -35 -5 0 -10 16 -10 35 0 19 5 35 10\n" +
    "                                                                                35 6 0 10 -16 10 -35z\" />\n" +
    "                                            <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                                                -20 -7 -20 -30z\" />\n" +
    "                                        </g>\n" +
    "                                    </svg> <label style=\"margin-left: 3px;\">{{data.activityPredictionLevelType.name}}</label><br>\n" +
    "                                </div>\n" +
    "                                <div ng-if=\"data.activityPredictionLevelType.name === 'Confident'\">\n" +
    "                                    <svg version=\"1.0\" xmlns=\"http://www.w3.org/2000/svg\" style=\"margin-left: 19px; padding-top:5px\"\n" +
    "                                        width=\"13.000000pt\" height=\"13.000000pt\" viewBox=\"0 0 16.000000 16.000000\"\n" +
    "                                        preserveAspectRatio=\"xMidYMid meet\">\n" +
    "\n" +
    "                                        <g transform=\"translate(0.000000,16.000000) scale(0.100000,-0.100000)\" fill=\"#000000\"\n" +
    "                                            stroke=\"none\">\n" +
    "                                            <path d=\"M110 75 c0 -58 2 -65 20 -65 18 0 20 7 20 65 0 58 -2 65 -20 65 -18\n" +
    "                                                        0 -20 -7 -20 -65z m30 0 c0 -30 -4 -55 -10 -55 -5 0 -10 25 -10 55 0 30 5 55\n" +
    "                                                        10 55 6 0 10 -25 10 -55z\" />\n" +
    "                                            <path d=\"M60 55 c0 -38 3 -45 20 -45 17 0 20 7 20 45 0 38 -3 45 -20 45 -17 0\n" +
    "                                                        -20 -7 -20 -45z\" />\n" +
    "                                            <path d=\"M10 40 c0 -23 4 -30 20 -30 16 0 20 7 20 30 0 23 -4 30 -20 30 -16 0\n" +
    "                                                        -20 -7 -20 -30z\" />\n" +
    "                                        </g>\n" +
    "                                    </svg> <label style=\"margin-left: 3px;\">{{data.activityPredictionLevelType.name}}</label><br>\n" +
    "                                </div>\n" +
    "                                <div ng-if=\"data.activityPredictionLevelType.name === 'AI suggested'\">\n" +
    "                                    <i class=\"bento-icon-info\" style=\"padding-left:20px ; padding-right: 5px;\"></i><label style=\"margin-left: 3px;\">{{data.activityPredictionLevelType.name}}</label><br>\n" +
    "                                </div>\n" +
    "                            </bmp-modal-content>\n" +
    "                        </bmp-modal>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::!vm.useTimersLayout\">\n" +
    "            <!-- Hours -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.TimeEntry.DailyEntry.Hours' -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.TimeEntry.DailyEntry.Minutes' -->\n" +
    "            <!-- /* i18nextract */'Bluemoon.TimeEntry.DailyEntry.Units' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"hours\"\n" +
    "                data-bmp-control-group-label=\"{{vm.getHoursLabelKey(vm.userPrefData.timeEntryStyle.id) | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'hours')\"\n" +
    "                data-bmp-control-group-hide=\"!vm.isTimeEntry()\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" id=\"hours\"\n" +
    "                    name=\"hours\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.$hours\"\n" +
    "                    ng-model-options=\"{ allowInvalid: true }\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"vm.getHoursFormat(vm.userPrefData.timeEntryStyle.id)\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    min=\"-99999.99\"\n" +
    "                    max=\"99999.99\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.TimeAndExpense.Hours\"\n" +
    "                    data-ng-disabled=\"vm.isFormReadOnly()\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::!vm.useTimersLayout\">\n" +
    "            <!-- Unit -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.TimeAndExpense.Units' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"units\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Units' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'units')\"\n" +
    "                data-bmp-control-group-hide=\"vm.isTimeEntry()\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" id=\"units\"\n" +
    "                    name=\"units\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.expenseUnits\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'n2'\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    min=\"-99999.99\"\n" +
    "                    max=\"99999.99\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.TimeAndExpense.Units\"\n" +
    "                    data-ng-disabled=\"vm.isFormReadOnly()\"/>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" bm-if-perm-some=\"['TimeAndBilling.ViewRates','TimeAndBilling.EditRates']\">\n" +
    "            <div ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\">\n" +
    "                <!-- Rate -->\n" +
    "                <!-- /* i18nextract */'Core.Captions.TimeAndExpense.EmployeeBillingRate' -->\n" +
    "                <div ng-if=\"!vm.userPrefData.employeeRateHide\" data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"employeeBillingRate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.EmployeeBillingRate' | translate | bmRequiredMark:!vm.useTimersLayout}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'employeeBillingRate')\"\n" +
    "                    data-bmp-control-group-hide=\"!vm.isTimeEntry()\">\n" +
    "                    <bmp-enum-combo enum=\"custom\"\n" +
    "                                    custom-items=\"vm.domain.rateOptions\"\n" +
    "                                    name=\"employeeBillingRate\"\n" +
    "                                    ng-model=\"vm.data.$employeeBillingRate\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    ng-required=\"vm.entryFormType === 0 && vm.isTimeEntry()\"\n" +
    "                                    ng-readonly=\"!vm.hasEditRates\"\n" +
    "                                    data-bmp-tab-stop=\"!vm.userPrefData.employeeRateSkip\">\n" +
    "                    </bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::!vm.useTimersLayout\">\n" +
    "            <div bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "            <!-- Unit Price -->\n" +
    "            <!-- /* i18nextract */'Core.Captions.TimeAndExpense.UnitPrice' -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"unitPrice\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.UnitPrice' | translate | bmRequiredMark}}\"\n" +
    "                data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'unitPrice')\"\n" +
    "                data-bmp-control-group-hide=\"vm.isTimeEntry()\"\n" +
    "                class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" id=\"unitPrice\"\n" +
    "                    name=\"unitPrice\"\n" +
    "                    type=\"text\"\n" +
    "                    class=\"form-control input-lg\"\n" +
    "                    data-ng-model=\"vm.data.unitPrice\"\n" +
    "                    data-bmp-clear-value=\"0\"\n" +
    "                    data-bmp-big-number=\"'c4'\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    min=\"0\"\n" +
    "                    max=\"99999.9999\"\n" +
    "                    data-bmp-control-group-field=\"Core.Captions.TimeAndExpense.UnitPrice\"\n" +
    "                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                    ng-readonly=\"!vm.hasEditAmounts\"/>\n" +
    "            </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::!vm.useTimersLayout\">\n" +
    "            <div bm-if-perm-some=\"['TimeAndBilling.ViewAmount','TimeAndBilling.EditAmounts']\">\n" +
    "                <!-- Amount -->\n" +
    "                <div ng-if=\"!vm.userPrefData.amountHide\" data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"amount\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Amount' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'amount')\"\n" +
    "                    class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "\n" +
    "                    <input autocomplete=\"off\" id=\"amount\"\n" +
    "                        name=\"amount\"\n" +
    "                        type=\"text\"\n" +
    "                        class=\"form-control input-lg\"\n" +
    "                        data-ng-model=\"vm.data.$amount\"\n" +
    "                        data-ng-model-options=\"{ updateOn: 'blur', allowInvalid: true }\"\n" +
    "                        data-bmp-big-number=\"'c2'\"\n" +
    "                        data-bmp-big-number-range-validator\n" +
    "                        bm-format-on-blur=\"\"\n" +
    "                        min=\"vm.minAmount\"\n" +
    "                        max=\"vm.maxAmount\"\n" +
    "                        data-bmp-control-group-field=\"Core.Captions.TimeAndExpense.Amount\"\n" +
    "                        data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                        ng-readonly=\"!vm.hasEditAmounts\"\n" +
    "                        data-bmp-tab-stop=\"!vm.userPrefData.amountSkip\" />\n" +
    "                    <a href ng-if=\"vm.data.amountIsOverridden\" class=\"input-lg bmp-info-inside-input-right bento-icon-info\" data-tooltip-placement=\"top\" data-tooltip-trigger=\"mouseenter\" data-uib-tooltip=\"{{'Core.Captions.TimeAndExpense.AmountIsOverridden' | translate }}\" data-tooltip-append-to-body=\"true\" data-qe-id=\"bm-timeDailyEntry-amountOverriden-tooltip\"></a>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\">\n" +
    "            <div ng-if=\"!vm.userPrefData.commentHide\" ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\" class=\"col-xs-12\">\n" +
    "                <!-- Comment -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"comment\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.Comment' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'comment')\">\n" +
    "                    <bmp-standard-text-input\n" +
    "                        id=\"comment\"\n" +
    "                        name=\"comment\"\n" +
    "                        label=\"{{'Core.Captions.TimeAndExpense.Comment' | translate }}\"\n" +
    "                        data-ng-model=\"vm.data.comment\"\n" +
    "                        data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                        tab-stop=\"!vm.userPrefData.commentSkip\"></bmp-standard-text-input>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-if=\"!vm.userPrefData.billerNoteHide\" ng-class=\"::vm.useTimersLayout ? 'col-sm-6' : 'col-sm-12'\" class=\"col-xs-12\">\n" +
    "                <!-- Biller note -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"billerNote\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.BillerNote' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'billerNote')\">\n" +
    "                    <bmp-standard-text-input\n" +
    "                        id=\"billerNote\"\n" +
    "                        name=\"billerNote\"\n" +
    "                        label=\"{{'Core.Captions.TimeAndExpense.BillerNote' | translate }}\"\n" +
    "                        data-ng-model=\"vm.data.billerNote\"\n" +
    "                        data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                        tab-stop=\"!vm.userPrefData.billerNoteSkip\"></bmp-standard-text-input>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"row\" ng-if=\"::(vm.entryFormType === 1 || vm.entryFormType === 2)\">\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <!-- /* i18nextract */'Core.Captions.TimeAndExpense.IntegrationApplication' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"integrationApplication\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.IntegrationApplication' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'integrationApplication')\">\n" +
    "                    <bmp-enum-combo enum=\"custom\"\n" +
    "                                    custom-items=\"vm.uniqueIntegrationApplications\"\n" +
    "                                    name=\"integrationApplication\"\n" +
    "                                    ng-model=\"vm.data.integrationApplication\"\n" +
    "                                    data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                                    data-ng-readonly=\"::vm.entryFormType === 2\"\n" +
    "                                    data-bmp-tab-stop=\"!vm.userPrefData.integrationApplication\">\n" +
    "                    </bmp-enum-combo>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"col-sm-6\">\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"activityLogDescription\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.TimeAndExpense.ActivityLogDescription' | translate}}\"\n" +
    "                    data-bmp-control-group-error=\"vm.detail.errorFor(vm.data, 'activityLogDescription')\">\n" +
    "                    <input autocomplete=\"off\" id=\"activityLogDescription\"\n" +
    "                            name=\"activityLogDescription\"\n" +
    "                            type=\"text\"\n" +
    "                            class=\"form-control input-lg\"\n" +
    "                            data-ng-model=\"vm.data.activityLogDescription\"\n" +
    "                            data-ng-disabled=\"vm.isFormReadOnly()\"\n" +
    "                            data-bmp-tab-stop=\"!vm.userPrefData.activityLogDescription\" />\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </fieldset>\n" +
    "    <div ng-if=\"!vm.useTimersLayout\" style=\"padding-bottom: 12px\">{{'Bluemoon.Practice.Common.Grid.RequiredItems' | translate}}</div>\n" +
    "    <button ng-if=\"vm.entryFormType !== 1\"\n" +
    "            type=\"button\"\n" +
    "            id=\"timeAndExpenseDailyEntryForm.save\"\n" +
    "            class=\"btn btn-primary\"\n" +
    "            data-ng-click=\"vm.save();\"\n" +
    "            data-ng-disabled=\"!vm.detail.canSave\"\n" +
    "            data-qe-id=\"bm-timeAndExpenseDailyEntryForm-{{vm.data.activityType.id | lowercase}}-save-button\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "    <button type=\"button\" id=\"timeAndExpenseDailyEntryForm.mergeAndSubmit\"\n" +
    "            class=\"btn btn-primary\"\n" +
    "            ng-if=\"vm.entryFormType === 1\"\n" +
    "            data-ng-click=\"vm.mergeAndSubmit();\"\n" +
    "            data-ng-disabled=\"vm.mergeAndSubmitDisabled()\"\n" +
    "            translate=\"Bluemoon.TimeEntry.Recap.EditConfirmationDialog.MergeAndSubmit\"></button>\n" +
    "    <button ng-if=\"vm.entryFormType === 1\"\n" +
    "            type=\"button\"\n" +
    "            id=\"timeAndExpenseDailyEntryForm.merge\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-ng-click=\"vm.save()\"\n" +
    "            translate=\"Bluemoon.TimeEntry.Recap.EditConfirmationDialog.Merge\"></button>\n" +
    "    <button type=\"button\" id=\"timeAndExpenseDailyEntryForm.cancel\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-ng-click=\"vm.cancelEdit();\"\n" +
    "            data-ng-disabled=\"vm.detail.isNew && !vm.detail.canSave\"\n" +
    "            data-qe-id=\"bm-timeAndExpenseDailyEntryForm-{{vm.data.activityType.id | lowercase}}-cancel-button\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Cancel\"></button>\n" +
    "    <button type=\"button\" id=\"timeAndExpenseDailyEntryForm.delete\"\n" +
    "            class=\"btn btn-default\"\n" +
    "            data-ng-click=\"vm.deleteEntry();\"\n" +
    "            data-ng-hide=\"vm.detail.isNew || vm.useTimersLayout\"\n" +
    "            translate=\"Bluemoon.Practice.Common.Actions.Delete\"></button>\n" +
    "</div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("main/src/entry/grid-entry/time-and-expense-grid-entry-project-details-modal.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/grid-entry/time-and-expense-grid-entry-project-details-modal.html",
    "<div>\n" +
    "    <div class=\"modal-header\">\n" +
    "        <button id=\"tasksDialog.close\"\n" +
    "                type=\"button\"\n" +
    "                class=\"close\"\n" +
    "                data-ng-click=\"ctrl.cancel()\"\n" +
    "                aria-hidden=\"true\">&times;</button>\n" +
    "        {{'Bluemoon.TimeEntry.GridEntry.Actions.ProjectDetails' | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"modal-body\" bento-busy-loader=\"ctrl.isSavingData || ctrl.detail.isLoadingData()\">\n" +
    "        <ng-form name=\"projectDetailsForm\">\n" +
    "            <ng-form name=\"projectDetailsForm_Project\">\n" +
    "                <!-- Project -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"projectName\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.GridEntry.ProjectDetails.ProjectName' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"ctrl.detail.errorFor(ctrl.item.projectScheduleItem, 'name')\">\n" +
    "                    <input autocomplete=\"off\"\n" +
    "                        id=\"projectName\"\n" +
    "                        name=\"projectName\"\n" +
    "                        type=\"text\"\n" +
    "                        class=\"form-control input-lg\"\n" +
    "                        readonly\n" +
    "                        data-ng-model=\"ctrl.item.projectScheduleItem.name\" />\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Date -->\n" +
    "                <div bm-if-has-license=\"ProjectManagement.Dates\"\n" +
    "                    data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"receivedDate\"\n" +
    "                    data-bmp-control-group-label=\"{{'Core.Captions.Project.ReceivedDate' | translate }}\"\n" +
    "                    data-bmp-control-group-error=\"ctrl.detail.errorFor(ctrl.projectData.project, 'receivedDate')\">\n" +
    "                    <bmp-bento-datepicker-wrapper id=\"projectReceivedDate\"\n" +
    "                        ng-model=\"ctrl.projectData.receivedDate\"\n" +
    "                        ng-change=\"ctrl.receivedDateChanged()\"\n" +
    "                        name=\"receivedDate\">\n" +
    "                    </bmp-bento-datepicker-wrapper>\n" +
    "                </div>\n" +
    "\n" +
    "                <!-- Project Tracking Description -->\n" +
    "                <!-- /* i18nextract */'Bluemoon.TimeEntry.GridEntry.ProjectDetails.ProjectTrackingDescription' -->\n" +
    "                <div data-bmp-control-group=\"\"\n" +
    "                    data-bmp-control-group-field-id=\"projectTrackingDescription\"\n" +
    "                    data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.GridEntry.ProjectDetails.ProjectTrackingDescription' | translate | bmRequiredMark:ctrl.hasProject() }}\"\n" +
    "                    data-bmp-control-group-error=\"ctrl.detail.errorFor(ctrl.projectData, 'trackingDescription')\">\n" +
    "                    <bmp-select-combo list=\"tracking-descriptions\"\n" +
    "                                    list-style=\"basic\"\n" +
    "                                    name=\"projectTrackingDescription\"\n" +
    "                                    ng-model=\"ctrl.projectData.trackingDescription\"\n" +
    "                                    on-change=\"ctrl.projectTrackingDescriptionChanged()\"\n" +
    "                                    required=\"ctrl.hasProject()\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "            </ng-form>\n" +
    "            <ng-form name=\"projectDetailsForm_Task\">\n" +
    "                <div bm-if-has-license=\"ProjectManagement.Tasks\">\n" +
    "                    <div bm-if-perm=\"ProjectManagement.Tasks\">\n" +
    "                        <!-- Task Name -->\n" +
    "                        <div data-bmp-control-group=\"ProjectManagement.Projects\"\n" +
    "                            data-bmp-control-group-field-id=\"taskName\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.GridEntry.ProjectDetails.TaskName' | translate }}\"\n" +
    "                            data-bmp-control-group-error=\"ctrl.detail.errorFor(ctrl.item.taskScheduleItem, 'name')\">\n" +
    "                            <input autocomplete=\"off\"\n" +
    "                                id=\"taskName\"\n" +
    "                                name=\"taskName\"\n" +
    "                                type=\"text\"\n" +
    "                                class=\"form-control input-lg\"\n" +
    "                                readonly\n" +
    "                                data-ng-model=\"ctrl.item.taskScheduleItem.name\" />\n" +
    "                        </div>\n" +
    "\n" +
    "                        <!-- Task Tracking -->\n" +
    "                        <!-- /* i18nextract */'Bluemoon.TimeEntry.GridEntry.ProjectDetails.TaskTrackingDescription' -->\n" +
    "                        <div data-bmp-control-group=\"\"\n" +
    "                            data-bmp-control-group-field-id=\"taskTrackingDescription\"\n" +
    "                            data-bmp-control-group-label=\"{{'Bluemoon.TimeEntry.GridEntry.ProjectDetails.TaskTrackingDescription' | translate | bmRequiredMark:ctrl.hasTask() }}\"\n" +
    "                            data-bmp-control-group-error=\"ctrl.detail.errorFor(ctrl.taskData, 'trackingDescription')\">\n" +
    "                            <bmp-select-combo list=\"tracking-descriptions\"\n" +
    "                                            list-style=\"basic\"\n" +
    "                                            name=\"taskTrackingDescription\"\n" +
    "                                            ng-model=\"ctrl.taskData.trackingDescription\"\n" +
    "                                            data-ng-disabled=\"ctrl.taskTrackingComboDisabled()\"\n" +
    "                                            ng-required=\"ctrl.hasTask()\">\n" +
    "                            </bmp-select-combo>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </ng-form>\n" +
    "            <div class=\"modal-footer\">\n" +
    "                <button id=\"tasksDialog.ok\"\n" +
    "                        class=\"btn btn-primary\"\n" +
    "                        data-ng-click=\"ctrl.save()\" data-translate=\"Bluemoon.Practice.Common.Actions.Save\"></button>\n" +
    "                <button id=\"tasksDialog.ok\"\n" +
    "                        class=\"btn btn-secondary\"\n" +
    "                        data-ng-click=\"ctrl.cancel()\" data-translate=\"Bluemoon.Practice.Common.Actions.Close\"></button>\n" +
    "            </div>\n" +
    "        </ng-form>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/entry/grid-entry/time-and-expense-grid-entry-standard-text.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/grid-entry/time-and-expense-grid-entry-standard-text.html",
    "<bmp-standard-text-input\n" +
    "    style=\"font-size: inherit; height: 100%; width: 100%\"\n" +
    "    container-visibility-changed=\"vm.onPopoverVisiblityChanged(visible)\"\n" +
    "    label=\"{{col.label | translate}}\"></bmp-standard-text-input>\n" +
    "");
}]);

angular.module("main/src/entry/grid-entry/time-and-expense-grid-entry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/grid-entry/time-and-expense-grid-entry.html",
    "<div ng-if=\"vm.isTimeEntry()\">\n" +
    "    <bmp-grid data-bmp-grid-definition=\"vm.timeDefinition\" data-bmp-grid-service=\"vm.provider\"></bmp-grid>\n" +
    "</div>\n" +
    "<div ng-if=\"!vm.isTimeEntry()\">\n" +
    "    <bmp-grid data-bmp-grid-definition=\"vm.expenseDefinition\" data-bmp-grid-service=\"vm.provider\"></bmp-grid>\n" +
    "</div>");
}]);

angular.module("main/src/entry/time-and-expense-entry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/entry/time-and-expense-entry.html",
    "<div class=\"container-fluid no-left-padding\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <h1 class=\"no-top-margin\" data-qe-id=\"bm-timeGridEntry-header-label\" id=\"titleText\">{{vm.title}}</h1>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-md-3 form-group\" bm-if-perm=\"TimeAndBilling.EditOtherStaffTimeAndExpense\">\n" +
    "                    <label data-qe-id=\"bm-timeAndExpenseGridEntry-Staff-label\">{{'Core.Captions.TimeAndExpense.Employee' | translate }}</label>\n" +
    "                    <bmp-select-combo\n" +
    "                        list=\"staff#active\"\n" +
    "                        aotf-default name=\"employee\"\n" +
    "                        ng-model=\"vm.employee\">\n" +
    "                    </bmp-select-combo>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-7\">\n" +
    "                    <bmp-date-range-selector name=\"bm-timeAndExpenseGridEntry-dateRangeSelector\"\n" +
    "                    data-qe-id=\"bm-timeAndExpenseGridEntry-dateRangeSelector\"\n" +
    "                    ng-if=\"vm.dateRangeSelectorOptions\"\n" +
    "                    bmp-date-range-selector-options=\"vm.dateRangeSelectorOptions\"\n" +
    "                    bmp-date-range-selector-options-default=\"WEEK\"\n" +
    "                    bmp-date-range-selector-changed=\"vm.onDateFilterChange({dateRangeId: dateRangeId, startDate: startDate, endDate: endDate})\">\n" +
    "                    </bmp-date-range-selector>\n" +
    "                </div>\n" +
    "                <div class=\"col-md-2 form-group bmp-btn-group-active\">\n" +
    "                    <div style=\"float:right\">\n" +
    "                        <label data-qe-id=\"bm-timeAndExpenseEntry-View-label\">{{'Bluemoon.TimeAndExpense.Entry.View' | translate }}</label>\n" +
    "                        <div class=\"btn-group title-case\" style=\"display:block\">\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"vm.selectedMode\" uib-btn-radio=\"'FORM'\">{{'Bluemoon.TimeAndExpense.Entry.Form' | translate }}</button>\n" +
    "                            <button type=\"button\" class=\"btn btn-default btn-toggle\" ng-model=\"vm.selectedMode\" uib-btn-radio=\"'GRID'\">{{'Bluemoon.TimeAndExpense.Entry.Grid' | translate }}</button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"row\">\n" +
    "                <!-- make large width 11 to fix a horizontal scrollbar bug w/ wijmo grid-->\n" +
    "                <div class=\"col-md-12\">\n" +
    "                    <bmp-view-mode-tabset bmp-view-mode-tabset-tabs=\"vm.tabs\" bmp-view-mode-tabset-orientation=\"top\" ng-class=\"vm.isGridEntry() ? 'tabset-no-padding' : ''\">\n" +
    "                        <div ng-if=\"vm.isGridEntry()\">\n" +
    "                            <time-and-expense-grid-entry\n" +
    "                                time-and-expense-grid-entry-employee=\"vm.employee\"\n" +
    "                                time-and-expense-grid-entry-date-filter=\"vm.dateFilter\"\n" +
    "                                time-and-expense-grid-entry-activity-type=\"vm.selectedType\"></time-and-expense-grid-entry>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"vm.isFormEntry()\">\n" +
    "                            <time-and-expense-daily-entry\n" +
    "                                time-and-expense-daily-entry-employee=\"vm.employee\"\n" +
    "                                time-and-expense-daily-entry-date-filter=\"vm.dateFilter\"\n" +
    "                                time-and-expense-daily-entry-activity-type=\"vm.selectedType\"></time-and-expense-daily-entry>\n" +
    "                        </div>\n" +
    "                    </bmp-view-mode-tabset>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/review/time-and-expense-review.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/review/time-and-expense-review.html",
    "<div class=\"container-fluid no-left-padding view-container no-bottom-margin\">\n" +
    "    <h1 class=\"no-top-margin\" data-qe-id=\"bm-timeAndExpenseReview-Header-label\">{{'Bluemoon.TimeAndExpense.ReviewTimeAndExpense' | translate}}</h1>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"setup-list-grid-view\">\n" +
    "                <div class=\"row\">\n" +
    "                    <bmp-slideout-panel bmp-slideout-panel-show=\"vm.showEntryForm()\">\n" +
    "                        <div class=\"col-md-4\">\n" +
    "                            <time-and-expense-entry-form\n" +
    "                            time-and-expense-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "                            time-and-expense-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id)\"\n" +
    "                            time-and-expense-entry-form-show-staff-control=\"true\"\n" +
    "                            time-and-expense-entry-form-use-timers-layout=\"false\"\n" +
    "                            time-and-expense-entry-form-employee=\"vm.employee\">\n" +
    "                            </time-and-expense-entry-form>\n" +
    "                        </div>\n" +
    "                    </bmp-slideout-panel>\n" +
    "                    <div ng-class=\"vm.isGridSmaller() ? 'col-md-8': 'col-md-12'\">\n" +
    "                        <div class=\"row filters\">\n" +
    "                            <!--LEFT SIDE GRID FILTERS-->\n" +
    "                            <div class=\"col-xs-12 col-md-8\">\n" +
    "                                <bmp-date-range-selector name=\"bm-timeAndExpenseReview-dateRangeSelector\" bmp-date-range-selector-options=\"vm.dateRangeSelectorOptions\" data-qe-id = \"bm-timeAndExpenseReview-DateRangeLabel\"\n" +
    "                                bmp-date-range-selector-options-default=\"WEEK\" bmp-date-range-selector-changed=\"vm.onFilterChange({dateRangeId: dateRangeId, startDate: startDate, endDate: endDate})\">\n" +
    "                                </bmp-date-range-selector>\n" +
    "                            </div>\n" +
    "\n" +
    "                            <!--RIGHT SIDE GRID FILTERS-->\n" +
    "                            <div class=\"col-xs-12 col-md-4\">\n" +
    "                                <div class=\"row bm-timeAndExpense-posted-and-approved bmp-btn-group-active\">\n" +
    "                                    <bmp-posted-and-approved-filters ng-if=\"vm.isApproveEnabled\"\n" +
    "                                                posted=\"vm.postedFilter\"\n" +
    "                                                approved=\"vm.approvedFilter\"\n" +
    "                                                on-changed=\"vm.onFilterChange()\"\n" +
    "                                                user-settings-key=\"vm.userSettingsKey\">\n" +
    "                                    </bmp-posted-and-approved-filters>\n" +
    "                                    <div class=\"btn-group title-case\">\n" +
    "                                        <button type=\"button\"\n" +
    "                                                class=\"btn btn-default btn-toggle\"\n" +
    "                                                ng-model=\"vm.$showBilledEntriesFilter\"\n" +
    "                                                data-qe-id=\"bm-timeAndExpenseReview-showBilledEntries-checkbox\"\n" +
    "                                                uib-btn-checkbox>\n" +
    "                                            {{ 'Bluemoon.TimeEntry.Review.ShowBilledEntries' | translate }}\n" +
    "                                        </button>\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                        <bmp-grid data-bmp-grid-definition=\"vm.definition\" data-bmp-grid-service=\"vm.provider\"></bmp-grid>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/time-and-expense-page.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/time-and-expense-page.html",
    "<div class=\"container-fluid no-padding-l\">\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <bmp-routable-tabset bmp-routable-tabset-tabs=\"vm.tabs\">\n" +
    "                <div ui-view class=\"enter-item-animation\"></div>\n" +
    "            </bmp-routable-tabset>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/timer/grid/timer-list-grid-client.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/timer/grid/timer-list-grid-client.html",
    "<div class=\"timer-list-grid-client\">\n" +
    "    <bmp-select-combo list=\"clients#active#frpTimeAndExpense\"\n" +
    "                name=\"client\"\n" +
    "                ng-model=\"vm.$client\"\n" +
    "                class=\"timer-list-grid-client-control\"\n" +
    "                append-to-parent=\".timer-list-grid-view\"\n" +
    "                tabindex=\"-1\"></bmp-select-combo>\n" +
    "</div>\n" +
    "\n" +
    "");
}]);

angular.module("main/src/timer/grid/timer-list-grid-detail.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/timer/grid/timer-list-grid-detail.html",
    "<div class=\"row\" style=\"padding-bottom:7px;height:33%\">\n" +
    "    <div class=\"col-xs-12 timer-grid-detail hidden-xs\">{{vm.formatDetail(vm.$item().engagement.code, vm.$item().projectScheduleItem.name)}}</div>\n" +
    "    <div class=\"col-xs-12 timer-grid-detail hidden-sm hidden-md hidden-lg\">{{vm.formatDetail(vm.$item().client.name, vm.$item().engagement.code, vm.$item().projectScheduleItem.name)}}</div>\n" +
    "</div>\n" +
    "<div class=\"row\" style=\"padding-bottom:7px;height:33%\">\n" +
    "    <div class=\"col-sm-6 col-xs-6 timer-grid-detail\" ng-if=\"vm.timeHasDetail(vm.$item())\">{{vm.formatDetail(vm.$item().activity.name, vm.$item().taskScheduleItem.name)}}</div>\n" +
    "    <div class=\"col-xs-6\" ng-if=\"!vm.timeHasDetail(vm.$item())\">\n" +
    "        <a class=\"timer-grid-edit-link\" href ng-click=\"vm.editItem(vm.$item())\">\n" +
    "        <span translate=\"Bluemoon.TimeEntry.Timer.TimerDetailColumnAddDetail\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "    <div class=\"col-sm-6 col-xs-6 text-right strong\" style=\"font-size:1.3em\">\n" +
    "        <i class=\"bento-icon-info\" style=\"cursor: pointer\" uib-tooltip-html=\"vm.getTooltip(vm.$item())\" tooltip-placement=\"bottom\" tooltip-trigger=\"'outsideClick'\" data-tooltip-append-to-body=\"true\"></i>\n" +
    "        {{vm.$item().$accumulatedTime}}\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" style=\"padding-bottom:7px;height:33%\">\n" +
    "    <div class=\"col-xs-12 timer-grid-detail\">\n" +
    "        <a class=\"timer-grid-edit-link\" href ng-click=\"vm.editItem(vm.$item())\">\n" +
    "        <span ng-if=\"vm.timeHasDetail(vm.$item())\" translate=\"Bluemoon.TimeEntry.Timer.TimerDetailColumnEditDetail\"></span>\n" +
    "        <span ng-if=\"!vm.timeHasDetail(vm.$item())\" translate=\"Bluemoon.TimeEntry.Timer.TimerDetailColumnEditDetail\" class=\"timer-visibility-hidden\"></span>\n" +
    "        </a>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/timer/grid/timer-list-grid-submit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/timer/grid/timer-list-grid-submit.html",
    "<div class=\"timer-grid-full-cell-button timer-grid-submit\"\n" +
    "     ng-class=\"{ 'timer-grid-submit-ready': vm.isReadyToSubmit(vm.$item()) }\"\n" +
    "     ng-click=\"vm.submitRow(vm.$item())\"\n" +
    "     data-tooltip-placement=\"top\"\n" +
    "     data-tooltip-trigger=\"mouseenter\"\n" +
    "     data-tooltip-popup-delay=\"500\"\n" +
    "     data-tooltip-append-to-body=\"true\"\n" +
    "     data-uib-tooltip=\"{{ 'Bluemoon.TimeEntry.Timer.SubmitTimersButton' | translate }}\">\n" +
    "     <div class=\"timer-grid-full-cell-table-cell\">\n" +
    "        <span\n" +
    "            class=\"timer-grid-full-cell-button-icon bento-icon-arrow-curved-right\">\n" +
    "        </span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/timer/grid/timer-list-grid-toggle-edit.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/timer/grid/timer-list-grid-toggle-edit.html",
    "<!-- /* i18nextract */'Bluemoon.TimeEntry.Timer.StopTimer' -->\n" +
    "<!-- /* i18nextract */'Bluemoon.TimeEntry.Timer.StartTimer' -->\n" +
    "<div class=\"timer-grid-full-cell-button timer-grid-toggle-edit\"\n" +
    "     ng-class=\"vm.processingOrRunning() ? 'bm-timer-running' : 'bm-timer-stopped'\"\n" +
    "     ng-click=\"vm.toggleTimer()\"\n" +
    "     bento-busy-loader=\"vm.$item().isProcessing\"\n" +
    "     bento-busy-loader-size=\"small\"\n" +
    "     data-tooltip-placement=\"top\"\n" +
    "     data-tooltip-trigger=\"mouseenter\"\n" +
    "     data-tooltip-popup-delay=\"500\"\n" +
    "     data-tooltip-append-to-body=\"true\"\n" +
    "     data-uib-tooltip=\"{{ vm.processingOrRunning() ? 'Bluemoon.TimeEntry.Timer.StopTimer' : 'Bluemoon.TimeEntry.Timer.StartTimer' | translate }}\">\n" +
    "     <div class=\"timer-grid-full-cell-table-cell\">\n" +
    "        <span\n" +
    "            data-qe-id=\"timer-list-grid-start-stop-timer\"\n" +
    "            ng-class=\"vm.processingOrRunning() ? 'bento-icon-pause' : 'bento-icon-play2'\"\n" +
    "            class=\"timer-grid-full-cell-button-icon\">\n" +
    "        </span>\n" +
    "    </div>\n" +
    "</div>");
}]);

angular.module("main/src/timer/timer.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/timer/timer.html",
    "<div class=\"container-fluid view-container\">\n" +
    "    <div bento-alert bento-alert-object=\"vm.alerts\"></div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12\">\n" +
    "            <div class=\"timer-list-grid-view\">\n" +
    "                <div ng-hide=\"vm.editingEntry\" class=\"timer-animation timer-set-width\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <h3 class=\"pull-left timer-list-grid-header\">{{ 'bm.header.timers.toggle' | translate }}</h3>\n" +
    "                        <div class=\"pull-right\">\n" +
    "                            <button id=\"tasksDialog.close\"\n" +
    "                                type=\"button\"\n" +
    "                                class=\"close pull-right\"\n" +
    "                                data-ng-click=\"vm.closeDropDown()\"\n" +
    "                                aria-hidden=\"true\">&times;</button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\">\n" +
    "                        <div bento-busy-loader=\"vm.showingGridThrobber\">\n" +
    "                            <bmp-grid bmp-grid-definition=\"vm.gridDefinition\" data-bmp-grid-service=\"vm.provider\" data-bmp-grid-before-load=\"vm.gridBeforeLoad($sender)\"></bmp-grid>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"timer-list-grid-footer\">\n" +
    "                        <span data-qe-id=\"bm-progressEntryForm-legend\" style=\"float:left\">{{ 'Bluemoon.Practice.Common.Grid.RequiredItems' | translate }}</span>\n" +
    "                        <div class=\"pull-right timer-list-grid-entry-link\">\n" +
    "                            <a role=\"button\" href=\"{{vm.timeAndExpenseUrl}}\" target=\"_blank\" class=\"btn btn-link btn-lg no-padding-r\">\n" +
    "                                {{ 'Bluemoon.TimeEntry.Timer.TimeEntry' | translate }} <i style=\"font-size:1.3em\" class=\"bento-icon-arrow-forward\"></i>\n" +
    "                            </a>\n" +
    "                        </div>\n" +
    "                        <div class=\"timer-list-grid-add-and-start\" data-ng-show=\"vm.showAddAndStart()\">\n" +
    "                            <button type=\"button\"\n" +
    "                                    class=\"btn btn-primary\"\n" +
    "                                    data-ng-click=\"vm.addAndStartNewTimer();\"><i class=\"bento-icon-add\" style=\"margin-right:5px;\"></i>{{ 'Bluemoon.TimeEntry.Timer.StartTimer' | translate }}\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div ng-if=\"vm.editingEntry\" class=\"timer-animation timer-set-width\">\n" +
    "                    <div class=\"row\">\n" +
    "                        <h3>{{ 'Bluemoon.TimeEntry.Timer.TimerDetailColumn' | translate }}</h3>\n" +
    "                    </div>\n" +
    "                    <div class=\"row\" bento-busy-loader=\"!vm.currentEmployee\">\n" +
    "                        <time-and-expense-entry-form\n" +
    "                            time-and-expense-entry-form-on-load=\"vm.onEntryFormLoad(controller)\"\n" +
    "                            time-and-expense-entry-form-reload-new-id-state-change=\"vm.reloadNewIdStateChange(id)\"\n" +
    "                            time-and-expense-entry-form-allow-new=\"false\"\n" +
    "                            time-and-expense-entry-form-entry-form-type=\"3\"\n" +
    "                            time-and-expense-entry-form-start-date=\"vm.getEntryDate()\"\n" +
    "                            time-and-expense-entry-form-total-time=\"vm.getAccumulatedTime()\"\n" +
    "                            time-and-expense-entry-form-employee=\"vm.currentEmployee\">\n" +
    "                        </time-and-expense-entry-form>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("main/src/user-preferences-setup/user-preferences-time-and-expense-entry-component.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("main/src/user-preferences-setup/user-preferences-time-and-expense-entry-component.html",
    "<h3 data-ng-show=\"$ctrl.detail.isLoadingData()\">{{$ctrl.detail.busyText}}</h3>\n" +
    "<ng-form id=\"userPreferencesTimeAndBillingTimeAndExpenseEntryForm\" name=\"userPreferencesTimeAndBillingTimeAndExpenseEntryForm\" data-ng-hide=\"$ctrl.detail.isLoadingData()\" autocomplete=\"off\">\n" +
    "<h3>{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.Section.FieldDefaultsAndSettings' | translate}}</h3>\n" +
    "<div class=\"row\">\n" +
    "    <!-- Default Date -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"defaultEntryDate\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.DefaultEntryDate' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'defaultEntryDate')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"user-preference-t-e-default-entry-date\"\n" +
    "                       name=\"defaultEntryDate\"\n" +
    "                       data-qe-id=\"defaultEntryDate\"\n" +
    "                       ng-model=\"$ctrl.data.defaultEntryDate\"\n" +
    "                       required=\"true\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\" bmp-if-user-permission=\"hasTimeAndBillingApplication\">\n" +
    "    <!-- Time Entry Style -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"timeEntryStyle\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.TimeEntryStyle' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'timeEntryStyle')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <bmp-enum-combo enum=\"user-preference-time-entry-style\"\n" +
    "                       name=\"timeEntryStyle\"\n" +
    "                       data-qe-id=\"timeEntryStyle\"\n" +
    "                       ng-model=\"$ctrl.data.$timeEntryStyle\"\n" +
    "                       required=\"true\"\n" +
    "                       on-change=\"$ctrl.onTimeEntryStyleChanged()\"></bmp-enum-combo>\n" +
    "    </div>\n" +
    "    <!-- Time Entry Minutes Per Time Span Unit -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "         data-bmp-control-group-field-id=\"timeEntryMinutesPerTimeSpanUnit\"\n" +
    "         data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.TimeEntryMinutesPerTimeSpanUnit' | translate}}\"\n" +
    "         data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'timeEntryMinutesPerTimeSpanUnit')\"\n" +
    "         class=\"col-md-4 col-sm-4 col-xs-12\"\n" +
    "         data-ng-if=\"$ctrl.domainModel.showTimeEntryMinutesPerTimeSpanUnit($ctrl.data)\">\n" +
    "        <input autocomplete=\"off\" type=\"number\"\n" +
    "               name=\"timeEntryMinutesPerTimeSpanUnit\"\n" +
    "               data-qe-id=\"timeEntryMinutesPerTimeSpanUnit\"\n" +
    "               ng-model=\"$ctrl.data.$timeEntryMinutesPerTimeSpanUnit\"\n" +
    "               ng-model-options=\"{ updateOn: 'blur', allowInvalid: false }\"\n" +
    "               bmp-integer=\"true\"\n" +
    "               min=\"1\"\n" +
    "               max=\"1440\"\n" +
    "               data-bmp-clear-value=\"6\"\n" +
    "               ng-required=\"true\"\n" +
    "               bmp-control-group-field=\"Core.Captions.ContactUserPrefTEEntry.TimeEntryMinutesPerTimeSpanUnit\"\n" +
    "               class=\"form-control\"\n" +
    "               data-ng-change=\"$ctrl.onTimeEntryMinutesPerTimeSpanUnitChanged()\"/>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!-- Hide and Skip Fields -->\n" +
    "    <div class=\"col-md-10 col-sm-10 col-xs-12\">\n" +
    "        <table class=\"bm-timeAndExpense-up-hide-skip-table bmp-user-preferences-table bento-flex-grid wj-content\">\n" +
    "            <tr class=\"wj-colheaders\">\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Header.FieldName' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Header.HideField' | translate}}</th>\n" +
    "                <th scope=\"col\" class=\"wj-header wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Header.SkipWhenTabbing' | translate}}</th>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.Date' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"entryDateHide\" name=\"entryDateHide\" data-qe-id=\"entryDateHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$entryDateHide\" />\n" +
    "                    <label for=\"entryDateHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EntryDateHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"entryDateSkip\" name=\"entryDateSkip\" data-qe-id=\"entryDateSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$entryDateSkip\" />\n" +
    "                    <label for=\"entryDateSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EntryDateSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.Project' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"projectHide\" name=\"projectHide\" data-qe-id=\"projectHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$projectHide\" />\n" +
    "                    <label for=\"projectHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.ProjectHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"projectSkip\" name=\"projectSkip\" data-qe-id=\"projectSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$projectSkip\" />\n" +
    "                    <label for=\"projectSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.ProjectSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr data-ng-if=\"$ctrl.domainModel.hasDisableProjectStatusIAC\">\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.ProjectStatus' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"projectStatusHide\" name=\"projectStatusHide\" data-qe-id=\"projectStatusHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$projectStatusHide\" />\n" +
    "                    <label for=\"projectStatusHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.ProjectStatusHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"projectStatusSkip\" name=\"projectStatusSkip\" data-qe-id=\"projectStatusSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$projectStatusSkip\" />\n" +
    "                    <label for=\"projectStatusSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.ProjectStatusSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.EngagementTemplate' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"engagementTemplateHide\" name=\"engagementTemplateHide\" data-qe-id=\"engagementTemplateHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$engagementTemplateHide\" />\n" +
    "                    <label for=\"engagementTemplateHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EngagementTemplateHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"engagementTemplateSkip\" name=\"engagementTemplateSkip\" data-qe-id=\"engagementTemplateSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$engagementTemplateSkip\" />\n" +
    "                    <label for=\"engagementTemplateSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EngagementTemplateSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr data-ng-if=\"$ctrl.domainModel.userAndFirmPermissionsEnabledForTask\">\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.Task' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"taskHide\" name=\"taskHide\" data-qe-id=\"taskHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$taskHide\" />\n" +
    "                    <label for=\"taskHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.TaskHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"taskSkip\" name=\"taskSkip\" data-qe-id=\"taskSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$taskSkip\" />\n" +
    "                    <label for=\"taskSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.TaskSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr data-ng-if=\"$ctrl.domainModel.hasDisableTaskStatusIAC\">\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.TaskStatus' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"taskStatusHide\" name=\"taskStatusHide\" data-qe-id=\"taskStatusHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$taskStatusHide\" />\n" +
    "                    <label for=\"taskStatusHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.TaskStatusHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"taskStatusSkip\" name=\"taskStatusSkip\" data-qe-id=\"taskStatusSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$taskStatusSkip\" />\n" +
    "                    <label for=\"taskStatusSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.TaskStatusSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.EmployeeRate' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"employeeRateHide\" name=\"employeeRateHide\" data-qe-id=\"employeeRateHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$employeeRateHide\" />\n" +
    "                    <label for=\"employeeRateHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EmployeeRateHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"employeeRateSkip\" name=\"employeeRateSkip\" data-qe-id=\"employeeRateSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$employeeRateSkip\" />\n" +
    "                    <label for=\"employeeRateSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.EmployeeRateSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.Amount' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"amountHide\" name=\"amountHide\" data-qe-id=\"amountHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$amountHide\" />\n" +
    "                    <label for=\"amountHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.AmountHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"amountSkip\" name=\"amountSkip\" data-qe-id=\"amountSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$amountSkip\" />\n" +
    "                    <label for=\"amountSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.AmountSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.Comment' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"commentHide\" name=\"commentHide\" data-qe-id=\"commentHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$commentHide\" />\n" +
    "                    <label for=\"commentHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.CommentHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"commentSkip\" name=\"commentSkip\" data-qe-id=\"commentSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$commentSkip\" />\n" +
    "                    <label for=\"commentSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.CommentSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "            <tr>\n" +
    "                <th scope=\"row\" class=\"wj-cell\">{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.HideSkipTable.Field.BillerNote' | translate}}</th>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"billerNoteHide\" name=\"billerNoteHide\" data-qe-id=\"billerNoteHide\" type=\"checkbox\" ng-model=\"$ctrl.data.$billerNoteHide\" />\n" +
    "                    <label for=\"billerNoteHide\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.BillerNoteHide' | translate}}</label>\n" +
    "                </td>\n" +
    "                <td class=\"wj-cell\">\n" +
    "                    <input id=\"billerNoteSkip\" name=\"billerNoteSkip\" data-qe-id=\"billerNoteSkip\" type=\"checkbox\" ng-model=\"$ctrl.data.$billerNoteSkip\" />\n" +
    "                    <label for=\"billerNoteSkip\" class=\"sr-only\">{{'Core.Captions.ContactUserPrefTEEntry.BillerNoteSkip' | translate}}</label>\n" +
    "                </td>\n" +
    "            </tr>\n" +
    "        </table>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<h3>{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.Section.TimerBehavior' | translate}}</h3>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <label for=\"timerAllowSimultaneousTimers\">\n" +
    "        <input id=\"timerAllowSimultaneousTimers\" name=\"timerAllowSimultaneousTimers\" data-qe-id=\"timerAllowSimultaneousTimers\" type=\"checkbox\" ng-model=\"$ctrl.data.$notTimerAllowSimultaneousTimers\" />\n" +
    "        {{'Core.Captions.ContactUserPrefTEEntry.TimerAllowSimultaneousTimers' | translate}}</label>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "        <label for=\"timerStartProjectTaskTimers\">\n" +
    "        <input id=\"timerStartProjectTaskTimers\" name=\"timerStartProjectTaskTimers\" data-qe-id=\"timerStartProjectTaskTimers\" type=\"checkbox\" ng-model=\"$ctrl.data.timerStartProjectTaskTimers\" style=\"margin-bottom:15px\" />\n" +
    "        {{'Core.Captions.ContactUserPrefTEEntry.TimerStartProjectTaskTimers' | translate}}</label>\n" +
    "    </div>\n" +
    "</div>\n" +
    "<div class=\"row\">\n" +
    "    <!-- Timer Rounding Method -->\n" +
    "    <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"timerRoundingMethod\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.TimerRoundingMethod' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor(data, 'timerRoundingMethod')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "        <bmp-enum-radio-group enum=\"timer-rounding-method\" name=\"timerRoundingMethod\"\n" +
    "                                ng-model=\"$ctrl.data.timerRoundingMethod\"></bmp-enum-radio-group>\n" +
    "    </div>\n" +
    "    <div data-ng-if=\"$ctrl.domainModel.showTimerRoundingDetails($ctrl.data)\">\n" +
    "        <!-- Rounding Increment -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"timerRoundingIncrementSeconds\"\n" +
    "            data-bmp-control-group-label=\"{{$ctrl.domainModel.timerRoundingIncrementLabel($ctrl.data)}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'timerRoundingIncrementSeconds')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "            <input autocomplete=\"off\" type=\"text\"\n" +
    "                name=\"timerRoundingIncrementSeconds\"\n" +
    "                data-qe-id=\"timerRoundingIncrementSeconds\"\n" +
    "                ng-model=\"$ctrl.data.$timerRoundingIncrementSeconds\"\n" +
    "                ng-model-options=\"{ updateOn: 'blur', allowInvalid: false }\"\n" +
    "                ng-required=\"true\"\n" +
    "                bmp-big-number=\"'N2'\"\n" +
    "                data-bmp-big-number-range-validator\n" +
    "                min=\"$ctrl.domainModel.calculateRoundingIncrementVmMin($ctrl.data)\"\n" +
    "                max=\"$ctrl.domainModel.calculateRoundingIncrementVmMax($ctrl.data)\"\n" +
    "                bmp-control-group-field=\"Core.Captions.ContactUserPrefTEEntry.TimerRoundingIncrement\"\n" +
    "                bm-format-on-blur=\"\"\n" +
    "                class=\"form-control\" /><br/>\n" +
    "\n" +
    "            <!-- Timer Accumulate Before Rounding -->\n" +
    "            <label>\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"ACCUMULATED\"\n" +
    "                    name=\"timerAccumulateBeforeRounding_ACCUMULATED\"\n" +
    "                    data-qe-id=\"timerAccumulateBeforeRounding_ACCUMULATED\"\n" +
    "                    ng-model=\"$ctrl.data.$timerAccumulateBeforeRounding\"\n" +
    "                    />\n" +
    "                {{'Bluemoon.TimeAndExpense.UserPreferenceSetup.RoundAccumulated' | translate}}\n" +
    "            </label><br/>\n" +
    "            <label>\n" +
    "                <input type=\"radio\"\n" +
    "                    value=\"EACH\"\n" +
    "                    name=\"timerAccumulateBeforeRounding_EACH\"\n" +
    "                    data-qe-id=\"timerAccumulateBeforeRounding_EACH\"\n" +
    "                    ng-model=\"$ctrl.data.$timerAccumulateBeforeRounding\"\n" +
    "                    />\n" +
    "                {{'Bluemoon.TimeAndExpense.UserPreferenceSetup.RoundEach' | translate}}\n" +
    "            </label><br/>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "\n" +
    "<div>\n" +
    "    <!-- Activity Log User Preferences -->\n" +
    "    <h3>{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.Section.ActivityLog' | translate}}</h3>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Merge Threshold -->\n" +
    "        <!-- /* i18nextract */'Bluemoon.TimeAndExpense.UserPreferencesSetup.Field.ActivityLogAutoMergeMinSeconds' -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "        data-bmp-control-group-field-id=\"actLogAutoMergeMinSeconds\"\n" +
    "        data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.ActLogAutoMergeMinSeconds' | translate}}\"\n" +
    "        data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'actLogAutoMergeMinSeconds')\"\n" +
    "        data-bmp-control-group-label-tooltip=\"'Bluemoon.TimeAndExpense.UserPreferencesSetup.Field.ActivityLogAutoMergeMinSeconds'\"\n" +
    "        class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "        <input autocomplete=\"off\"\n" +
    "            type=\"number\"\n" +
    "            name=\"actLogAutoMergeMinSeconds\"\n" +
    "            data-qe-id=\"actLogAutoMergeMinSeconds\"\n" +
    "            ng-model=\"$ctrl.data.actLogAutoMergeMinSeconds\"\n" +
    "            ng-model-options=\"{ updateOn: 'blur', allowInvalid: false }\"\n" +
    "            ng-required=\"true\"\n" +
    "            bmp-integer\n" +
    "            min=\"1\"\n" +
    "            max=\"100800\"\n" +
    "            bmp-control-group-field=\"Core.Captions.ContactUserPrefTEEntry.ActLogAutoMergeMinSeconds\"\n" +
    "            bm-format-on-blur=\"\"\n" +
    "            class=\"form-control\" />\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 col-sm-12 col-xs-12\">\n" +
    "            <label for=\"actLogTrackInactiveTime\">\n" +
    "            <input id=\"actLogTrackInactiveTime\" name=\"actLogTrackInactiveTime\" data-qe-id=\"actLogTrackInactiveTime\" type=\"checkbox\" ng-model=\"$ctrl.data.actLogTrackInactiveTime\" />\n" +
    "            {{'Core.Captions.ContactUserPrefTEEntry.ActLogTrackInactiveTime' | translate}}</label> <i class=\"bento-icon-question\"\n" +
    "            uib-tooltip=\"{{ 'Bluemoon.TimeAndExpense.UserPreferencesSetup.Field.ActLogTrackInactiveTimeDetails' | translate }}\"\n" +
    "            tooltip-trigger=\"mouseenter\"\n" +
    "            tooltip-placement=\"right\"\n" +
    "            tooltip-append-to-body=\"true\"></i>\n" +
    "            <br />\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "            data-bmp-control-group-field-id=\"actLogTrackInactiveMinMinutes\"\n" +
    "            data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.ActLogTrackInactiveMinMinutes' | translate}}\"\n" +
    "            data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'actLogTrackInactiveMinMinutes')\"\n" +
    "            class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" type=\"number\"\n" +
    "                    name=\"actLogTrackInactiveMinMinutes\"\n" +
    "                    data-qe-id=\"actLogTrackInactiveMinMinutes\"\n" +
    "                    ng-model=\"$ctrl.data.actLogTrackInactiveMinMinutes\"\n" +
    "                    bmp-integer=\"true\"\n" +
    "                    min=\"1\"\n" +
    "                    max=\"1440\"\n" +
    "                    data-bmp-clear-value=\"10\"\n" +
    "                    ng-required=\"true\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.ContactUserPrefTEEntry.ActLogTrackInactiveMinMinutes\"\n" +
    "                    class=\"form-control\"\n" +
    "                    ng-disabled = \"$ctrl.domainModel.disableActLogTrackInactiveMinMinutes($ctrl.data)\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <!-- Activity Log Rounding Method -->\n" +
    "        <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"actLogRoundingMethod\"\n" +
    "                data-bmp-control-group-label=\"{{'Core.Captions.ContactUserPrefTEEntry.ActLogRoundingMethod' | translate}}\"\n" +
    "                data-bmp-control-group-error=\"$ctrl.detail.errorFor(data, 'actLogRoundingMethod')\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-6\">\n" +
    "            <bmp-enum-radio-group enum=\"timer-rounding-method\" name=\"actLogRoundingMethod\"\n" +
    "                                    ng-model=\"$ctrl.data.actLogRoundingMethod\"></bmp-enum-radio-group>\n" +
    "        </div>\n" +
    "        <div data-ng-if=\"$ctrl.domainModel.showActLogRoundingDetails($ctrl.data)\">\n" +
    "            <!-- Activity Log Rounding Increment -->\n" +
    "            <div data-bmp-control-group=\"\"\n" +
    "                data-bmp-control-group-field-id=\"actLogRoundingIncrementSeconds\"\n" +
    "                data-bmp-control-group-label=\"{{$ctrl.domainModel.actLogRoundingIncrementLabel($ctrl.data)}}\"\n" +
    "                data-bmp-control-group-error=\"$ctrl.detail.errorFor($ctrl.data, 'actLogRoundingIncrementSeconds')\"\n" +
    "                class=\"col-md-4 col-sm-4 col-xs-12\">\n" +
    "                <input autocomplete=\"off\" type=\"text\"\n" +
    "                    name=\"actLogRoundingIncrementSeconds\"\n" +
    "                    data-qe-id=\"actLogRoundingIncrementSeconds\"\n" +
    "                    ng-model=\"$ctrl.data.$actLogRoundingIncrementSeconds\"\n" +
    "                    ng-model-options=\"{ updateOn: 'blur', allowInvalid: false }\"\n" +
    "                    ng-required=\"true\"\n" +
    "                    bmp-big-number=\"'N2'\"\n" +
    "                    data-bmp-big-number-range-validator\n" +
    "                    min=\"$ctrl.domainModel.calculateRoundingIncrementVmMin($ctrl.data)\"\n" +
    "                    max=\"$ctrl.domainModel.calculateRoundingIncrementVmMax($ctrl.data)\"\n" +
    "                    bmp-control-group-field=\"Core.Captions.ContactUserPrefTEEntry.ActLogRoundingIncrement\"\n" +
    "                    bm-format-on-blur=\"\"\n" +
    "                    class=\"form-control\" />\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "            <span>{{'Bluemoon.TimeAndExpense.UserPreferencesSetup.AutomaticallyMergeRecentEntries' | translate}}</span>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "            <label for=\"actLogAutoMergeTRApps\">\n" +
    "            <input id=\"actLogAutoMergeTRApps\" name=\"actLogAutoMergeTRApps\" data-qe-id=\"actLogAutoMergeTRApps\" type=\"checkbox\" ng-model=\"$ctrl.data.actLogAutoMergeTRApps\" />\n" +
    "            {{'Bluemoon.TimeAndExpense.UserPreferencesSetup.ContactUserPrefTEEntry.ActLogAutoMergeTRApps' | translate}}</label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-8 col-sm-8 col-xs-8\">\n" +
    "            <label for=\"actLogAutoMergeNonTRApps\">\n" +
    "            <input id=\"actLogAutoMergeNonTRApps\" name=\"actLogAutoMergeNonTRApps\" data-qe-id=\"actLogAutoMergeNonTRApps\" type=\"checkbox\" ng-model=\"$ctrl.data.actLogAutoMergeNonTRApps\" />\n" +
    "            {{'Bluemoon.TimeAndExpense.UserPreferencesSetup.ContactUserPrefTEEntry.ActLogAutoMergeNonTRApps' | translate}}</label>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</div>\n" +
    "</ng-form>\n" +
    "");
}]);

angular.module("server-check/index.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("server-check/index.html",
    "<Status xmlns:i=\"http://www.w3.org/2001/XMLSchema-instance\" xmlns=\"http://schemas.datacontract.org/2004/07/Cobalt.BlueMoonClients.Web.Models\">\n" +
    "    <Resources>\n" +
    "        <Result>OK</Result>\n" +
    "    </Resources>\n" +
    "</Status>\n" +
    "");
}]);
